import {
  Component,
  OnInit,
  EventEmitter,
  ElementRef,
  Output,
  ViewChild,
  ViewEncapsulation,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { Title, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ApiService } from '../../../api/api.service';
import { AssistanceTicket } from '../../../models/assistanceticket';
import { AssistanceCase } from '../../../models/assistancecase';
import { Update } from '../../../models/update';
import { AssistanceTicketsStepComponent } from './assistance-tickets-step/assistance-tickets-step.component';
import { CreateAssistanceBillFormComponent } from '../../assistance-bills/create-assistance-bill-form/create-assistance-bill-form.component';
import { AssistanceTicketExceptionComponent } from './assistance-ticket-exception/assistance-ticket-exception.component';
import { ServiceConfigComponent } from './service-config/service-config.component';

import { FileUploadV2Component } from 'src/app/components/file-upload-v2/file-upload-v2.component';
import { ConfService } from '../../../services/conf.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { MeService } from '../../../services/me.service';
import { User } from '../../../models/user';
import * as _ from 'lodash';
//import {DistancecalculService} from '../../../services/distancecalcul.service';
import { TranslateService } from '@ngx-translate/core';
import { IamService } from '../../../services/iam.service';
import { SelectLocationComponent } from '../../select-location/select-location.component';
import { LoaderService } from '../../../api/loader.service';
import { AssistanceTicketsTypesService } from './assistance-tickets-types.service';
import { AssistanceReprocess } from '../../../models/assistance-reprocess';
import { AssistanceTicketSvc } from '../services/assistance-ticket.service';
import moment from 'moment';
// import { promise } from 'selenium-webdriver';
import { Attachment, ATTACHMENT_STATUS } from '../../../models/attachment';
import { NotificationService } from '../../../services/notification.service';
import { AssistancePlanService } from '../../../models/assistance-plan-service';
import { AssistanceService } from 'src/app/models/assistanceservice';
import { AssistanceProvider } from 'src/app/models/assistance-provider';
import { AssistancePrice } from 'src/app/models/assistance-price';
import { Country } from 'src/app/models/country';
import { isUndefined } from 'lodash';
import { environment } from '../../../../environments/environment';
import { FirebaseService } from 'src/app/services/firebase.service';
import { child, get, off, onValue, ref, set, update } from 'firebase/database';
declare var google: any;

import { DialogService } from 'primeng/dynamicdialog';
import { getDatabase, onChildAdded, push } from 'firebase/database';
import { StorageService } from 'src/app/services/storage.service';
import {
  trigger,
  style,
  transition,
  animate,
} from '@angular/animations';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ClientAssistanceCaseInfoComponent } from '../../client-assistance-case-info/client-assistance-case-info.component';
import { MapFeaturesService } from 'src/app/services/map-features.service';
import { CatalogCacheService } from 'src/app/services/catalog-cache.service';

interface areaReembolso {
  name: string,
  code: string
}
interface reasonReimbursement {
  name: string,
  code: string
}

export class Location {
  latitude: number;
  longitude: number;
}

interface IconAction {
  icon: string;
  title: string;
  click: (servicegroup: any) => void;
  condition: (servicegroup: any) => boolean;
}



import Swal from 'sweetalert2'
@Component({
    selector: 'app-assistance-tickets',
    templateUrl: './assistance-tickets.component.html',
    styleUrls: ['./assistance-tickets.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [AssistanceTicketSvc, MessageService],
    animations: [
        trigger('slideUpDown', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(30px)' }),
                animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
            ]),
            transition(':leave', [
                animate('150ms ease-in', style({ opacity: 0, transform: 'translateY(30px)' }))
            ])
        ])
    ],
    standalone: false
})




export class AssistanceTicketsComponent implements OnInit, OnDestroy, AfterViewInit {
  readonly ASSISTANCE_TICKET_TYPE: number = 3;

  client_classification = [];


  // All tickets of case
  editevent = new EventEmitter<void>();
  showClientView = false
  showProviderView = false
  //---nueva variable para mostrar la vista de reasignar usuario
  showReasignProviderView = false
  country_id: number;
  showRisks: boolean = false;
  showComplaints: boolean = false;
  risk_id: number = null;
  risks: any[] = [];
  complaints: any[] = [];
  groupsRisk: any;
  groupsComplaint: any;
  ambulance_id = [19, 139, 155, 241, 475, 518, 521, 522, 526, 531, 532, 619, 631, 637, 133, 916]
  cont = 0;
  showletter = false
  showletter2 = false
  showletter3 = false
  showletter4 = false
  showletter5 = false
  showletterdiscount = false
  showlettercopago = false;

  plan_max_amount_events = null;
  copago = false
  pago_copago = 0
  observation_copago = ""
  program_subtype: any = null;

  assistancetickets: any[] = [];
  // Last tickets of each service of case
  servicegroups: any[] = [];
  // Tickets of each service of case
  servicegrouptickets: any[] = [];
  case_id: number = null;
  user_id: number = null;
  status: number = null;
  case_status: number = null;
  case_end_date: number = null;
  member_id: number = null;
  contact_name: string = null;
  phone: string = null;
  phone2: string = null;
  address: string = null;
  email_: string = null;
  service_address: string = null;
  groupservicename: string = null;
  assistancecase: AssistanceCase;
  editupdate: Update;
  sendupdates: any[] = [];
  updatecases: any[] = [];
  assistancecategories: any[] = [];
  countries: any[] = [];
  providers: any[] = [];
  showCommentDialog = false;
  its_free = false;
  showCommentUserDialog = false;
  showEditDialog = false;
  editcommentflag = false;
  alertDialog = false;
  showCreateDialog = false;
  newticket = false;
  showstep: boolean[] = [];
  editedTicket?: AssistanceTicket = null;
  closedticket?: AssistanceTicket = null;
  totalCount = 0;
  page = 1;
  ticketbtnshow: { [id: string]: boolean } = {};
  showCancelBtn: { [id: string]: boolean };
  editbtnshow: { [id: string]: boolean } = {};
  arrivedTicket = new EventEmitter<any>();
  cartaPorte = new EventEmitter<any>();
  disableallstep = new EventEmitter<void>();
  commentTicket = new EventEmitter<any>();
  cancelTicket = new EventEmitter<any>();
  createTicket = new EventEmitter<void>();
  setAttachment = new EventEmitter<Attachment>();
  //providerLocationRT = new EventEmitter<any>();

  caseLocation: any = {};
  geocoder: any = null;
  editphoneFlag = false;
  NoeditphoneFlag = true
  YeseditphoneFlag = false
  editphone2Flag = false;
  editaddressFlag = false;
  editemailFlag = false;
  editlat: number = null;
  editlng: number = null;
  iAm = null;
  hasRole = null;
  modifyDate = false;
  addService_isDisabled = false;
  clientEndTime: { [id: string]: any } = {};
  providerStartTime: { [id: string]: any } = {};
  providerEndTime: { [id: string]: any } = {};
  notifyToCustomerStartTime: { [id: string]: any } = {};
  notifyToCustomerEndTime: { [id: string]: any } = {};
  programedTicketStartTime: { [id: string]: any } = {};
  ArrivalStartTime: { [id: string]: any } = {};
  ArrivalEndTime: { [id: string]: any } = {};
  country_code: any = {
    country_name: '',
    country_local: '',
  };
  carTicketInfo: AssistanceTicket;
  showPreviewDialog = false;
  showPreviewDialogConditionFile = false;
  showeditManual = false;
  showMap = new EventEmitter<boolean>();
  sale_canceled: boolean;
  navigationSubscription;
  images = [];

  CabinException = false
  CabinExceptionAuthorized = false
  sort_date_desc = true;
  showCourtesyDialog = false;
  courtesy_ = 0;
  //sort_date_asc = false
  showaditionalinformation = false;
  additionalplanservice: AssistancePlanService;
  plan_id;
  consumido;
  disponible;
  excedente2;
  user;
  agente = '';
  complete_address = '';
  survey_options = false;
  whatsapp = false;

  triage_window = false
  stopLightNumber = 0

  tieneCartaPorte = false;

  stepperReadOnly = false;
  globalTimeZone = new Date();
  hourTimeZone = 0;

  PROVIDER_STATUS_TICKET = {
    willGo: 1,
    wontGo: 2
  }
  assistanceProducts: any[] = [];
  shortProducts: any[] = [];
  assistanceplans: any[] = [];
  assistancesales: any[] = [];
  selectedSale: any;
  provider: AssistanceProvider;
  provider_site_data: any;
  PLAN_BY_CONECTION_ID;
  @ViewChild(SelectLocationComponent) locationComponent: SelectLocationComponent;
  @ViewChild(AssistanceTicketsStepComponent) stepComponent;
  @ViewChild(CreateAssistanceBillFormComponent) createbillComponent;
  @ViewChild(AssistanceTicketExceptionComponent)
  AssistanceTicketExceptionComponent;
  @ViewChild(ServiceConfigComponent) ServiceConfigComponent;

  @Output() cancelEvent = new EventEmitter();

  serviceCategories: any;
  isDisabled = new EventEmitter<boolean>();
  // For confirm supervisor dialog
  isdisabled_confirm = false;
  billprice: any = null;
  supervisor: User = new User();
  showSupervisorDialog = false;
  showwarinningmessage = false;
  cancelprovider: { [id: string]: boolean } = {};
  confirmticket?: any = null;
  confirmbill?: any = null;
  ticketpositions: any[] = [];
  cancelDialog = false;
  showroute = false;
  isClientLocation = false;
  isProviderLiveLocation = false;
  eventLocation = new EventEmitter<any>();
  serviceConfiguration = false;
  showExceptionDialog = false;
  showBillFormDialog = false;
  goprovider: { [id: string]: any } = {};
  serviceConfigTicket = new EventEmitter<any>();
  exceptionTicket = new EventEmitter<any>();
  editInterval: any;
  showDestinationAddress = false;
  /* providerAppLocation: any = {
    "latitude":null,
    "longitude": null
  } */

  isReprocessDialogVisible: boolean;
  pendingAddMapButton: boolean;
  listenActiveIndexes: any;
  nextTicketTypes: any;
  checkStepPending: any;
  fromBillCreationClose: boolean;
  showProviderDialog = false;
  showCaseFormDialog = false;
  case_provider_id = new EventEmitter<number>();
  case_provider_site_id = new EventEmitter<number>();
  case_coverage_id = new EventEmitter<number>();
  case_service_id = new EventEmitter<number>();
  Ticket = new EventEmitter<number>();

  applicant_name = new EventEmitter<string>();
  applicant_id = new EventEmitter<number>();
  country_event = new EventEmitter<number>();
  country = new EventEmitter<number>();
  service2 = new EventEmitter<number>();


  provider_address_ = new EventEmitter<any>();
  provider_name_ = new EventEmitter<any>();

  // service = new EventEmitter<number>();
  providers_re = new EventEmitter<any>();
  service_id: number = null;
  service: AssistanceService;
  provider_id: number = null;
  provider_site_id: number = null;
  coverage_id: number = null;
  caseAudios = [];
  audioFlag = true;
  caseAssignedToMe: boolean = false;
  // private tipoOrden: string = "nombre";

  // buca
  sds_provider = false;
  sinister_plan_service = false;
  buca_plan_service = false;
  buca_max_amount = 0;
  buca_amount_available = 0;
  buca_currency = '';
  blockSteps = false;
  dentalLetter = false;
  existProvider = false;
  patient_data: any;
  codes = false;
  buca_codes = []
  showBucaCodesDialog = false
  case_buca_id = new EventEmitter<number>();
  reassignTicket = new EventEmitter<any>();

  expand_more: boolean;
  showPopUpMore: boolean;
  showConfirmByConection: boolean;
  showConfirmByRecordination: boolean;
  showPhonesNumberDialog: boolean;
  showConfirmByReimburse: boolean;
  assistance_programming_types: any = [];
  assistance_programming_subtypes: any = [];
  exceptionsType: any = [];
  supervisors: any = [];
  text_general: string = '';
  showDialogGeneral: boolean;
  showProgramedService: boolean;
  showAudiosDialog: boolean = false;
  commentServiceConfig: string;
  groupServiceConfig: any;
  programTimeService: any;
  itemSelected: any;
  supervisorSelectedException: any;
  flagAssignProvider: boolean = false;
  // Flags computed from dynamic fields (es feriado, es de noche, etc.)
  flagIsHoliday: boolean = false;
  flagIsDangerZone: boolean = false;

  customerMap: any;
  mapOptions: any = {};
  mapOverlays: any = [];
  urlStaticMap: string = '';
  API_KEY: string = environment.googleMapsApiKey;
  isEmbeddedMap: boolean = true;
  embeddedMapUrl: SafeResourceUrl;

  remaining_assistances: number;
  courtesy_assistances: number;
  inperiod_assistances: number;
  used_services: number;
  audioList: any = [];
  countryy: Country;

  //For provider asigned view
  provider2: AssistanceProvider = null;
  prices: AssistancePrice = null;
  provider_site: any = null;
  coverage: any = null;
  showReassignProviderDialog: boolean;
  showUnassignedModal: boolean;
  unAssignedProvider: boolean;

  ticketProviderExists: boolean = false;

  close_ticket_on_cancel: boolean;

  isDefaultProviderSite: boolean = false;

  //---variable para desactivar boton de encuesta
  disabledSendSurvey: boolean = false;

  //flag for show car info only in vial services
  showVial: boolean;

  //crefisa
  assistanceSaleCar: any;

  showHistoryDialog = false;
  setSale = new EventEmitter<any>();

  sale_status: number;
  isMemberDisabled: boolean;
  products: any[] = [];
  searching: Boolean = false;
  typeSearch: number = 9;
  member_name = '';
  members: any[] = null;
  member_national_id: any;
  sales: any = [];
  readonly TYPE_SEARCH = {
    COVER_LETTER: 1,
    NAME: 2,
    POLICY: 3,
    REFERENCE: 4,
    RFC: 5,
    SERIE: 6,
    PHONE: 7,
    BY_CONECTION: 8,
    MANUAL_CASE: 90,
    CAR_PLATE: 99,
    CAR_ENGINE_NUMBER: 50,
    CAR_SERIAL_NUMBER: 55,
    EMAIL: 65,
    TAX_NUMBER: 70
  };
  search_sale_status = null;
  resultDialog: boolean;
  resultDialogMember: boolean;
  showCountryError: boolean = false;
  key: string;
  policy: string;
  inciso: string;
  companyName: string = null;
  reference: string;
  serie: string;
  indexselectsale: number = 0;
  SALE_CANCELLED_THEN_BY_CONNECTION: boolean = false;
  interval: any;

  channels = {
    1: 'Llamada Telefonica',
    2: 'Whatsapp',
    3: 'Roadmap'
  }
  showCaseFormDialogTicketInfo: boolean;
  public _assistanceList: AssistanceCases;

  // DESCOMENTAR TAREA EMILIA
  // sendEmailCommunication = {
  //   member_name:'',
  //   saving:'',
  //   plan:'',
  //   product:'',
  //   service:'',
  //   phone_number:'',
  //   email:'',
  // }
  isCaseApp: boolean = false;

  //condicionado
  showUploadFileDialog = false;
  fileTypesCondicionado: any = {
    112: 'Condicionado'
  };
  caseAttachmentsCondicionado: any[] = [];
  totalCountCaseAttachmentsCondicionado: number = 0;
  timezoneOffset = 0;
  setAttachmentCondicionado = new EventEmitter<Attachment>();
  showPreviewDialogCondicionado = false;
  //---variables para llamada a componente generico de survey
  customer_phone = ""
  id_survey = 0
  currentProcessId = 0
  customer_email = ""
  country_id_survey = 0
  customer_name = ""
  open = false;


  // Upload Files 
  showFilesView: boolean = false;
  showBillFormDialogTemp = false;
  filesToImport: Array<Attachment> = [];
  caseAttachments: any[] = [];
  totalCountCaseAttachments: number = 0;
  fileTypes: any = {
    51: 'Reimbursement document',
    120: 'Cabin Exception Authorization',
    113: 'Evidence',
    150: 'Letter of Authorization',
    999: 'Other',
    // 52: 'Porte Card',
    // 53: 'Sinister',
    // 54: 'Official release of vehicle in deposit',
    // 55 : 'Claims Quotation / Authorization',
    // 56 : 'Prior authorization from the Claims area',
    // 57: 'Documents evidence'
  };
  acceptedTypes: string[] = [
    ".png",
    ".jpg",
    ".jpeg",
    ".pdf",
    ".xls",
    ".xlsx",
    '.xml',
    '.XML',
  ];

  provider_letter: any;

  show_schedule_appointment: boolean = false
  appointment_date: any;
  db: any;
  answers: any;
  answers_text: any;
  last_provider_national_id: number;
  hasTicketReimburse = false;
  showReimbursementAmount: boolean = false;
  groupsReimbursementAmount: any;
  hasCaseReimbursementAmount = false;
  reimburseAmountComment = ""
  showreimbursementalert: boolean = false;
  supervisors_reimbursements = []


  areasReembolso!: areaReembolso[];

  selectedAreasReembolso: areaReembolso[] = []; // Aquí se guardarán los valores seleccionados


  reasonsReembolso!: reasonReimbursement[];
  selectedReasonsReembolso: reasonReimbursement[] = [];


  //--nuevas variables para obtener localizacion en este componente
  showRequestLocation: boolean;

  @ViewChild('selectLocationComp')
  selectLocationComponent: SelectLocationComponent;
  location_key = ""
  location_key_update = ""
  editLocation = new Location();
  google_address_origen: String = '';
  memberLocation = new EventEmitter<any>();

  stateLocation = new EventEmitter<any>();
  otherPhone = null;
  checkedPhone = true;
  checkedPhone2 = false;
  selectedPhone = 1;

  arrivalcode: any;


  //---validar latitude longitud
  have_coordinates = true;
  msgs: any[] = [];
  applyLinkService: boolean = false;
  showChatModal = false;
  selectedTicket: any = null;
  chatMessages: any[] = [];
  chatInput: string = '';
  canReply: boolean = false;
  selectedImageUrl: string | null = null;
  @ViewChild('scrollMe') private scrollContainer!: ElementRef;
  showChatDialog = false;
  @ViewChild('cameraInput') cameraInput!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    public el: ElementRef,
    public conf: ConfService,
    private loaderService: LoaderService,
    private router: Router,
    private me: MeService,
    private api: ApiService,
    private confirmation: ConfirmationService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private iam: IamService,
    private titleService: Title,
    private typesService: AssistanceTicketsTypesService,
    public ticketSvc: AssistanceTicketSvc,
    private notificationService: NotificationService,
    private messageService: MessageService,
    private LoaderService: LoaderService,
    private firebaseService: FirebaseService,
    private dialogService: DialogService,
    private storageService: StorageService,
    private dialog: MatDialog,
    private mapFeaturesService: MapFeaturesService,
    private catalogCache: CatalogCacheService,
    private sanitizer: DomSanitizer

  ) {
    this.embeddedMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.google.com/maps/embed/v1/place?key=${environment.googleMapsApiKey}&q=CiudaddeGuatemala`
    );
    this.iAm = this.iam.isRole;
    this.hasRole = this.iam.hasThisRole;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.initialize();
      }
    });

    this.showDialogGeneral = true;

    this.expand_more = false;
    this.showPopUpMore = false;
    this.showConfirmByConection = false;
    this.showConfirmByRecordination = false;
    this.showPhonesNumberDialog = false;
    this.showConfirmByReimburse = false;
    this.showProgramedService = false;
    this.showReassignProviderDialog = false;
    this.showUnassignedModal = false;
    this.unAssignedProvider = false;
    this.hourTimeZone = (this.globalTimeZone.getTimezoneOffset() / 60) * -1;


    this.catalogCache.getTypologiesCrm({ catalog: 'risk_events', o_all: true })
      .toPromise()
      .then((response) => {
        if (response.count > 0) {
          this.risks = response.data[0].typologies;
        }
      })
      .catch((e) => {
        console.error('Error loading risk events:', e);
        this.risks = [];
      });


    this.api.typologies
      .get()
      .params({ catalog: 'assitance_complaints' })
      .all()
      .promise()
      .then((response) => {
        if (response.count > 0) {
          this.complaints = response.data[0].typologies;
        }
      })
      .catch((e) => (this.complaints = []));
    this.showVial = false;
  }

  assetsBaseUrl: string = 'https://storage.googleapis.com/apolo11-prod.appspot.com/';

  openAuthorization() {
    let new_ticket = _.cloneDeep(this.servicegrouptickets[this.servicegroups[0].service_id][0]);
    new_ticket.ticket_type = 36
    new_ticket.user_id = this.user_id
    this.dialog.open(FileUploadV2Component, {
      data: {
        'user_id': this.user_id,
        'ticket': new_ticket,
        'case_id': this.case_id
      },
      width: '70vw',
      height: '70vh',
      maxHeight: '700px',
      minWidth: '350px',
      maxWidth: '800px'
    }).afterClosed().subscribe((data) => {
      if (data) {
        this.CabinExceptionAuthorized = true;
        this.initialize();
      }
    })
  }

  openExceptionSwal(ticket: any) {
    const currencySymbol = this.assistancecase?.country?.currency_symbol || '';

    const options = this.exceptionsType
      .sort((a: { name: string }, b: { name: string }) => a.name.localeCompare(b.name))
      .map((t: { id: number; name: string }) => `<option value="${t.name}">${t.name}</option>`)
      .join('');

    Swal.fire({
      title: "Solicitar excepción",
      html: `
      <div style="text-align: left; margin-top: 15px;">
        <label for="swal-authorizer" style="font-weight: bold;">¿Quién autorizó?</label>
        <input id="swal-authorizer" type="text" class="form-control mb-3" placeholder="Nombre de quien autorizó">

        <label for="swal-amount" style="font-weight: bold;">Monto</label>
        <div class="input-group mb-3">
          <span class="input-group-text">${currencySymbol}</span>
          <input id="swal-amount" type="text" class="form-control" placeholder="Ingrese un monto">
        </div>

        <label for="swal-reason" style="font-weight: bold;">Motivo:</label>
        <select id="swal-reason" class="form-control mb-3">
          <option value="">Seleccione un motivo</option>
          ${options}
        </select>

        <label for="swal-comment" style="font-weight: bold;">Comentario:</label>
        <textarea id="swal-comment" class="form-control" rows="3" placeholder="Ingrese un comentario"></textarea>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: '<span class="px-4">Solicitar</span>',
      cancelButtonText: 'Cancelar',
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-secondary',
        popup: 'swal2-border-radius'
      },
      didOpen: () => {
        const amountInput = document.getElementById('swal-amount') as HTMLInputElement;

        amountInput.addEventListener('input', function () {
          let value = this.value.replace(/[^0-9.]/g, '');
          const parts = value.split('.');
          if (parts.length === 2 && parts[1].length > 2) {
            value = parts[0] + '.' + parts[1].slice(0, 2);
          }
          this.value = value;
        });
      },
      preConfirm: () => {
        const authorizerInput = document.getElementById('swal-authorizer') as HTMLInputElement;
        const amountInput = document.getElementById('swal-amount') as HTMLInputElement;
        const reasonInput = document.getElementById('swal-reason') as HTMLInputElement;
        const commentInput = document.getElementById('swal-comment') as HTMLTextAreaElement;

        const authorizer = authorizerInput?.value.trim();
        const amount = amountInput?.value.trim();
        const reason = reasonInput?.value.trim();
        const comment = commentInput?.value.trim();

        if (!authorizer || authorizer.length < 3) {
          Swal.showValidationMessage('Debe ingresar quién autorizó (mínimo 3 caracteres)');
          return {};
        }

        if (!amount || isNaN(Number(amount)) || Number(amount) <= 0) {
          Swal.showValidationMessage('Debe ingresar un monto válido mayor a 0');
          return {};
        }

        if (!/^\d+(\.\d{1,2})?$/.test(amount)) {
          Swal.showValidationMessage('El monto debe tener como máximo dos decimales');
          return {};
        }

        if (!reason || reason.length < 5) {
          Swal.showValidationMessage('Debe ingresar un motivo (mínimo 5 caracteres)');
          return {};
        }

        if (!comment || comment.length < 5) {
          Swal.showValidationMessage('El comentario debe tener al menos 5 caracteres');
          return {};
        }

        return {
          authorizer,
          amount: parseFloat(amount),
          reason,
          comment
        };
      }
    }).then(result => {
      if (result.isConfirmed && result.value) {
        const { authorizer, amount, reason, comment } = result.value;
        this.submitAuthorizedException(authorizer, amount, reason, comment);
      }
    });
  }







  submitAuthorizedException(authorizer: string, amount: number, reason: string, comment: string) {
    const currencySymbol = this.assistancecase?.country?.currency_symbol || ''
    let ticket: AssistanceTicket
    ticket = _.cloneDeep(this.servicegrouptickets[this.servicegroups[0].service_id][0])

    ticket.ticket_type = 35
    ticket.exception_amount = amount
    ticket.number_provider = null
    ticket.user_id = Number(this.user_id)
    ticket.comment = `Se solicita autorización a ${authorizer}, Monto a autorizar: ${currencySymbol} ${amount.toFixed(2)}, con motivo: ${reason}, ${comment}`
    ticket.exception_authorizer_name = authorizer
    ticket.exception_reason = reason
    this.api.assistancetickets.create(ticket).promise().then((Response: any) => {
      this.initialize();
      this.CabinException = true;
    });
  }



  initialize() {
    this.interval = setInterval(() => {
      if (!isUndefined(google)) {
        clearInterval(this.interval)
        this.mapOptions = {
          center: {
            lat: 14.590518806702539,
            lng: -90.51070153590592,
          },
          zoom: 13,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
          },
        };
        this.additionalplanservice = new AssistancePlanService();
        this.audioFlag = true;


        this.loaderService.display(true);
        this.fromBillCreationClose = true;
        this.iAm = this.iam.isRole;
        this.case_id = this.route.snapshot.params['id'];
        this.isAssistanceCaseApp();
        this.user_id = this.getMe().id;
        if (this.route.snapshot.params['status'] != null) {
          this.status = parseInt(this.route.snapshot.params['status']);
        }
        if (this.route.snapshot.params['member_id'] != null) {
          this.member_id = parseInt(this.route.snapshot.params['member_id']);
        }

        this.messageService.clear();
        this.validateCaseLinkService(this.route.snapshot.params['id'])
        this.isReprocessDialogVisible = false;
        this.pendingAddMapButton = false;
        this.listenActiveIndexes = {};
        this.nextTicketTypes = {};
        this.showCancelBtn = {};
        this.checkStepPending = {};
        this.servicegrouptickets = [];
        //
        this.supervisor = new User();
        this.geocoder = new google.maps.Geocoder();
        this.caseLocation = null;
        this.assistancecase = new AssistanceCase();
        this.editedTicket = new AssistanceTicket();
        this.closedticket = new AssistanceTicket();
        this.editupdate = new Update();
        this.editupdate.type = 3;
        this.editupdate.user_id = this.user_id;
        this.editupdate.item_id = Number(this.case_id);
        this.serviceCategories = [];

        this.api.assistanceCasesById
          .get(this.case_id)
          .params({ check_ticket: true })
          .promise()
          .then((c) => {
            this.assistancecase = c;

            this.location_key = this.assistancecase.location_key
            this.location_key_update = this.assistancecase.location_key_update





            //-verifico si aplica o no aplica encuesta para desactivar el boton
            if (this.assistancecase.apply_survey == false) {
              this.disabledSendSurvey = true
            }

            // Disable provider assign is provider not assignable
            if (!this.assistancecase.provider_is_assignable) {
              this.stepperReadOnly = true;
            } else {
              this.stepperReadOnly = false;
            }

            // If me operator of this case
            if (
              this.assistancecase.created_by &&
              this.getMe().id == this.assistancecase.created_by.id
            ) {
              this.caseAssignedToMe = true;
            }

            this.contact_name = this.assistancecase.contact_name;
            this.phone = this.assistancecase.phone;
            this.phone2 = this.assistancecase.phone2;
            this.address = this.assistancecase.address;
            this.email_ = this.assistancecase.email;
            this.editlat = this.assistancecase.latitude;
            this.editlng = this.assistancecase.longitude;
            this.plan_id = this.assistancecase.assistance_plan_id;
            this.editupdate.user_updated_id = this.assistancecase.member_id;
            this.editedTicket.state_id = this.assistancecase.state_id;
            this.sale_canceled = c.sale_canceled;
            this.setMap(this.assistancecase);
            this.case_status = this.assistancecase.status;
            this.case_end_date = this.assistancecase.date_end;
            this.api.assistancePlansAndProducts.get(this.plan_id).promise()
              .then(async resp => {

                if (resp[5]) {
                  this.buca_plan_service = true
                  this.getCategoriesGroup()
                  if (this.assistancecase?.assistance_sale?.category == 'BUCA INSURANCE') {
                    this.api.buca.getPolicyAmountInfo(this.assistancecase?.assistance_sale?.code, this.assistancecase.member.id).promise()
                      .then(rsp => {
                        this.buca_max_amount = rsp.max_amount.toFixed(2);
                        this.buca_amount_available = rsp.amount_available.toFixed(2);
                        this.buca_currency = rsp.currency_code;
                      })
                      .catch(err => {

                      });
                  }
                };
                if (resp[4]) {
                  this.sinister_plan_service = true
                };
              });
            this.getCompleteAddress(this.assistancecase.member);
            this.getAssistanceTicket().then(() => {
              this.setFlagsByTicket();

              // this.api.updates
              //   .get()
              //   .filter(update_filter)
              //   .sort('update_date', true)
              //   .params({ check_ticket: true })
              //   .all()
              //   .promise()
              //   .then((updates) => {
              //     this.updatecases = updates.data;
              //   });
              const currentDate = this.getCurrentDateInCountryTimezone();
              const currentTime = currentDate.getUTCHours() * 60 + currentDate.getUTCMinutes();
              this.calculateEsFeriado(currentDate);
              this.mapFeaturesService.getMapFeatureDangerZones({ lat: this.editlat, lng: this.editlng }).then((isInDangerZone) => {
                this.flagIsDangerZone = isInDangerZone;
              });
              this.api.countries
                .get()
                .promise()
                .then((c) => {
                  this.countries = c.data;
                });
            });

            this.getBills();

          });

        const update_filter = {
          type: this.editupdate.type,
          item_id: this.editupdate.item_id,
        };

        this.getAnswers(this.case_id);

        this.api.extra.getAssistanceSaleCar(this.case_id)
          .promise()
          .then((assSaleCar) => {
            this.assistanceSaleCar = assSaleCar;
          }).catch((e) => { });

        this.getLetter();

        // this.getCompleteAddress(this.assistancecase.member.id)
        // this.getAudioCasesv2();
        // this.getCompleteAddress(this.assistancecase.member)
        this.audioFlag = false;
        // this.api.assistancecasesaudio.getAllAudiosInCase(this.case_id).promise().then(case_audios =>{
        //   if(case_audios["CallList"].length != 0){
        //     for (let i = 0; i < case_audios["CallList"].length; i++) {
        //       const element = case_audios["CallList"][i];
        //       let url = "https://apolo11.online/api/assistancecalls/getAudio?" + "giid="+element["keys"]["globalInteractionId"]+"&convert=false&stepid="+element["keys"]["callerInteractionStepId"]
        //       let tmpData = {
        //         "showAudio":false,
        //         "audioURL": url,
        //         "startTime": this.cleanDate(element["startTime"]),
        //         "callerLastName":element["callerLastName"],
        //         "pkId":element["pkId"],
        //         "agentDispositionName":element["agentDispositionName"],
        //         "showButton":true,
        //       }
        //       if(this.caseAudios.some(audio => audio.pkId === tmpData["pkId"])){

        //       } else{
        //         this.caseAudios.push(tmpData)
        //       }
        //     }
        //   }
        // })
        //this.getProviderInfo();
        this.getFirebaseCaseInfo(this.case_id);
        this.loadSupervisors();
      }
    }, 100)
  }

  async getFirebaseCaseInfo(case_id) {
    var assistance_cases: AssistanceCases;
    await this.getAssistanceForRealTime(case_id).then(value => {
      assistance_cases = value as AssistanceCases;
    });

    this._assistanceList = assistance_cases;
    localStorage.getItem(case_id.toString()) === "1" ? localStorage.setItem("_caseProviderStatus_" + case_id.toString(), this._assistanceList.status.toString()) : localStorage.setItem("_caseProviderStatus_" + case_id.toString(), "");
  }

  getAssistanceForRealTime(case_id) {
    var assistance_cases: AssistanceCases;
    return new Promise((resolve, reject) => {
      const dbRefAssistanceCases = ref(this.db, 'asistance_cases');
      const childAssistanceCases = child(dbRefAssistanceCases, case_id.toString());
      onValue(childAssistanceCases, (snap) => {
        let value = snap.val();
        assistance_cases = value as AssistanceCases;
        if (localStorage.getItem(case_id.toString()) == "1" && assistance_cases.status > +localStorage.getItem("_caseProviderStatus_" + case_id.toString())) {
          localStorage.setItem("_caseProviderStatus_" + case_id.toString(), assistance_cases.status.toString());
          window.location.reload();
        } else {
          resolve(value);
        }
      });
    });
  }

  ngOnInit() {
    this.loadExceptionType();

    this.getTipologies();

    this.db = this.firebaseService.db;
    // this.initialize();
    this.notificationService.notificationRefresh$.subscribe((payload) =>
      this.onNotificationReceived(payload)
    );
    //this.getProviderInfo();

    this.api.catalog.getByGrouper('TICKET_REIMBURSEMENT_AREA').promise().then(res => {
      this.areasReembolso = res.map(area => { return { name: area.description_es, code: area.description_es } })
    })

    this.api.catalog.getByGrouper('TICKET_REIMBURSEMENT_REASON').promise().then(res => {
      this.reasonsReembolso = res.map(area => { return { name: area.description_es, code: area.description_es } })
    })


  }
  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['isAssistanceChat']) {
        this.openChat()
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { isAssistanceChat: null },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });

      }

    });
  }
  getCompleteAddress(member) {
    this.api.assistances
      .getcompleteaddress(member.id)
      .promise()
      .then((resp) => {
        this.complete_address = resp;
      });
  }

  activateClientInformation() {
    this.showClientView = true;
    this.showDialogGeneral = false;

    this.api.assistancecases
      .getClientInformation(this.assistancecase.member.id)
      .promise()
      .then((data) => {

        this.text_general = data;
      })
      .catch((error) => {


      });
  }


  showCaseHistory() {
    this.setSale.emit(this.assistancecase.assistance_sale_id)
    this.showHistoryDialog = true;
  }

  async getAudioCasesv2() {

    this.audioFlag = true;
    this.cont += 1;
    try {

      let data: any = [];
      let data2: any = [];
      let datar: any = [];
      this.loaderService.display(true);
      this.api.columbusCalls.getDataFromColumbus({ "call_id": this.case_id }).promise().then(
        async req => {
          datar = req;
          data2 = datar;




          var canInsert = false;
          datar.forEach(element1 => {
            let duplicated = false;
            let count = 0;
            canInsert = this.compareWithCurrentData(element1, data)

            if (canInsert) {
              data.push(element1)
            }
            /*data2.forEach(element2 => {
              if(element1.pkId == element2.pkId){

              }else{
                if(element1.caller_interaction_step_id == element2.caller_interaction_step_id){
                  duplicated = true;
                  count = count + 1;
                }
              }
                
            });*/

          });
          this.api.columbusCalls.getToken().promise().then(
            req => {
              this.loaderService.display(false);
              let tokendata: any = req.access_token




              let token = tokendata;

              if (data.length != 0) {



                for (let i = 0; i < data.length; i++) {
                  let element = data[i];
                  let tmpData = {

                  }
                  if (element.caller_login_id == "None") {
                    tmpData = {
                      "showAudio": false,
                      "audioURL": "https://apolo11.online/api/getColumbusAudios/" + element.global_interaction_id + "/" + element.callee_interaction_step_id + "/" + token,
                      "startTime": element.start_time + 'Z',
                      "callerLastName": element.callee_login_id,
                      "pkId": element.pkId,
                      "agentDispositionName": "",
                      "showButton": true,
                      "pkid": element.pkId
                    }
                  } else {
                    tmpData = {
                      "showAudio": false,
                      "audioURL": "https://apolo11.online/api/getColumbusAudios/" + element.global_interaction_id + "/" + element.caller_interaction_step_id + "/" + token,
                      "startTime": element.start_time + 'Z',
                      "callerLastName": element.caller_login_id,
                      "pkId": element.pkId,
                      "agentDispositionName": "",
                      "showButton": true,
                      "pkid": element.pkId
                    }
                  }

                  if (this.caseAudios.some(audio => audio.pkId === tmpData["pkId"])) { }
                  else {

                    this.caseAudios.push(tmpData)


                  }
                }
                this.audioFlag = false;
              }
            },
            err => {
              this.loaderService.display(false);
              this.ticketMessage({ 'severity': 'error', 'summary': 'Error', 'detail': 'Error al obtener los audios del caso.' })
            }
          )



        },
        err => {
          this.loaderService.display(false);
          this.ticketMessage({ 'severity': 'error', 'summary': 'Error', 'detail': 'Error al obtener los audios del caso.' })
        }
      )
    } catch (exception) {
      this.loaderService.display(false);
      // this.ticketMessage({'severity': 'error', 'summary': 'Error', 'detail': 'Error al obtener los audios del caso.'})

      if (this.cont <= 9) {
        this.getAudioCasesv2();
        this.audioFlag = false;
      } else {
        this.audioFlag = false;
      }

    }

  }


  compareWithCurrentData(element1, data) {

    let returningValue = true;
    data.forEach(element => {
      if (element.caller_interaction_step_id == element1.caller_interaction_step_id) {
        returningValue = false;
      } else {
        returningValue = true;
      }
    });
    return returningValue;
  }

  async getAudioCases() {
    this.audioFlag = true;
    this.api.assistancecasesaudio
      .getAllAudiosInCase(this.case_id)
      .promise()
      .then((cases_audios) => {

        if (cases_audios.code === 500) {
          this.getAudioCases();
        } else {
          if (cases_audios.data.length != 0) {
            for (let i = 0; i < cases_audios.data.length; i++) {
              let element = cases_audios.data[i];

              let url =
                'https://apolo11.online/api/assistancecalls/getAudio?' +
                'giid=' +
                element.keys.globalInteractionId +
                '&convert=false&stepid=' +
                element.keys.callerInteractionStepId;
              let tmpData = {
                showAudio: false,
                audioURL: url,
                startTime: this.cleanDate(element.startTime),
                callerLastName: element.callerLastName,
                pkId: element.pkId,
                agentDispositionName: element.agentDispositionName,
                showButton: true,
              };

              if (
                this.caseAudios.some((audio) => audio.pkId === tmpData['pkId'])
              ) {
              } else {
                this.caseAudios.push(tmpData);

              }
            }
          }
        }
        this.audioFlag = false;
      });
  }



  getBills() {
    this.api.assistancebills
      .get()
      .filter({ case_id: this.case_id })
      .sort('updated_time', true)
      .page(this.page)
      .promise()
      .then((bills) => {
        if (Array.isArray(bills.data)) {
          _.forEach(bills.data, (bill) => {
            if (bill.carta_porte_data) {
              this.tieneCartaPorte = true;
            }
          });
        }
        // this.bills = bills.data;
        // this.total = bills.total;
      });
  }

  getAudio(pkId) {
    for (let i = 0; i < this.caseAudios.length; i++) {
      const audio = this.caseAudios[i];
      if (audio['pkId'] == pkId) {
        audio['showButton'] = false;
        audio['showAudio'] = true;
      }
    }
  }

  async setMap(Case: AssistanceCase): Promise<void> {
    const hasCaseCoordinates = Case.latitude != null && Case.longitude != null &&
      Case.latitude !== 0 && Case.longitude !== 0;

    if (hasCaseCoordinates) {
      this.setCoordinates(Case.latitude, Case.longitude)
      this.caseLocation = {
        latitude: Case.latitude,
        longitude: Case.longitude,
      };
      this.mapOptions = {
        ...this.mapOptions,
        center: {
          lat: Case.latitude,
          lng: Case.longitude,
        },
      };
      this.eventLocation.emit(this.caseLocation);
    } else {
      this.setCoordinates(null, null);
      this.caseLocation = null;
      await this.centerMapByCountry(Case.country?.name);
    }

    if (
      this.iAm([
        'assistance_admin',
        'supervisor',
        'operator',
        'cabin_agent',
        'assistance_dispatcher',
        'assistance_dispatcher_vial',
        'assistance_dispatcher_medical',
      ])
    ) {
      this.pendingAddMapButton = true;
    }
  }

  private async centerMapByCountry(countryName?: string): Promise<void> {
    if (!this.geocoder || !countryName) {
      return;
    }

    try {
      await new Promise<void>((resolve) => {
        this.geocoder.geocode({ address: countryName }, (results, status) => {
          if (status === 'OK' && results?.[0]) {
            const location = results[0].geometry.location;
            this.mapOptions = {
              ...this.mapOptions,
              center: {
                lat: location.lat(),
                lng: location.lng(),
              },
            };
          }
          resolve();
        });
      });
    } catch (error) {
      console.warn('No se pudo centrar el mapa en el país del caso', error);
    }
  }

  private getCurrentDateInCountryTimezone(): Date {
    if (!this.countryy || this.countryy.timezone === undefined || this.countryy.timezone === null) {
      console.warn('No hay información de timezone del país, usando UTC');
      return new Date();
    }

    // Obtener la fecha actual en UTC
    const now = new Date();

    const timezoneOffsetMinutes = this.countryy.timezone * 60;

    const countryDate = new Date(now.getTime() + (timezoneOffsetMinutes * 60 * 1000));

    return countryDate;
  }

  private async calculateEsFeriado(currentDate: Date) {
    try {
      if (!this.assistancecase?.country?.id) {
        console.log('No hay country_id disponible para verificar feriados');
        return;
      }

      // Obtener feriados del país
      const holidays = await this.api.catalogEquivalence.getHolidays().promise();
      console.log('Feriados obtenidos:', holidays);

      // Filtrar feriados del país actual
      const countryHolidays = holidays.filter((holiday: any) =>
        holiday.value_ === this.assistancecase?.country?.id.toString()
      );

      console.log('Feriados del país actual:', countryHolidays);

      // Formatear fecha actual como MM-DD
      const currentMonthDay = `${String(currentDate.getUTCMonth() + 1).padStart(2, '0')}-${String(currentDate.getUTCDate()).padStart(2, '0')}`;
      console.log('Fecha actual (MM-DD):', currentMonthDay);

      // Verificar si la fecha actual coincide con algún feriado
      const isHoliday = countryHolidays.some((holiday: any) => {
        console.log('Comparando feriado:', {
          from_: holiday.from_,
          to_: holiday.to_,
          currentMonthDay: currentMonthDay
        });

        // Construir fecha del feriado en formato MM-DD
        // Si from_ y to_ son DD y MM respectivamente, construir MM-DD
        let holidayDate = '';
        if (holiday.from_ && holiday.to_) {
          // Asumir que from_ es día y to_ es mes
          holidayDate = `${String(holiday.to_).padStart(2, '0')}-${String(holiday.from_).padStart(2, '0')}`;
        } else if (holiday.from_ && holiday.from_.includes('-')) {
          // Si ya está en formato MM-DD
          holidayDate = holiday.from_;
        }

        console.log('Fecha del feriado construida:', holidayDate);

        // Comparar fechas
        const matches = holidayDate === currentMonthDay;

        console.log('¿Coincide?', {
          holidayDate,
          currentMonthDay,
          matches
        });

        return matches;
      });

      this.flagIsHoliday = isHoliday;

    } catch (error) {
      console.error('Error al calcular es_feriado:', error);
    }
  }

  editCasephone() {

    this.editphoneFlag = true;
    const inputPhone = this.el.nativeElement.querySelector('.input1');
    inputPhone.style.display = 'block';
    inputPhone.focus();
    inputPhone.select();
  }

  editCasephone2() {
    this.editphone2Flag = true;
    const inputPhone2 = this.el.nativeElement.querySelector('.input3');
    inputPhone2.style.display = 'block';
    inputPhone2.focus();
    inputPhone2.select();
  }

  editCaseaddress() {
    this.editaddressFlag = true;
    const inputAddr = this.el.nativeElement.querySelector('.input2');
    inputAddr.style.display = 'block';
    inputAddr.focus();
    inputAddr.select();
  }

  editCaseemail() {
    this.editemailFlag = true;
    const inputAddr = this.el.nativeElement.querySelector('.input5');
    inputAddr.style.display = 'block';
    inputAddr.focus();
    inputAddr.select();
  }
  onSetLocation(latlng) {
    this.editlat = latlng.latitude;
    this.editlng = latlng.longitude;
  }

  updateLocation() {
    this.messageService.clear();
    this.sendupdates = [];
    if (
      this.assistancecase.latitude === this.editlat &&
      this.assistancecase.longitude === this.editlng
    ) {
      return;
    }

    let lat = null,
      lng = null;
    this.editupdate.item_name = 'latitude,longitude';
    if (this.assistancecase.latitude !== null)
      lat = this.assistancecase.latitude.toString();
    if (this.assistancecase.longitude !== null)
      lng = this.assistancecase.longitude.toString();
    this.editupdate.value_old = lat + ', ' + lng;
    this.assistancecase.latitude = this.editlat;
    this.assistancecase.longitude = this.editlng;
    this.editupdate.value_new =
      this.editlat.toString() + ', ' + this.editlng.toString();
    this.sendupdates.push(this.editupdate);
    const modify_data = {
      updates: this.sendupdates,
    };

    this.api.assistanceCasesById
      .putUpdate(this.assistancecase.id, modify_data)
      .promise()
      .then((d) => {
        this.caseLocation = {
          latitude: d[0].latitude,
          longitude: d[0].longitude,
        };
        this.getservicegroup();
        const updatedata = d[1];
        updatedata.forEach((u) => {
          this.updatecases.unshift(u);
        });
        this.translate.get('Case location updated').subscribe((res: string) => {
          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: `${res}: ${d[0].id}`,
          });
        });
      });
  }

  updateCaseinfo() {
    this.editphoneFlag = false;
    this.editphone2Flag = false;
    this.editaddressFlag = false;
    this.editemailFlag = false;
    this.messageService.clear();
    this.sendupdates = [];
    const inputPhone = this.el.nativeElement.querySelector('.input1');
    //inputPhone.style.display = 'none';
    /*const inputAddr = this.el.nativeElement.querySelector('.input2');
    inputAddr.style.display = 'none';*/
    const inputPhone2 = this.el.nativeElement.querySelector('.input3');
    //inputPhone2.style.display = 'none';
    /*const inputemail = this.el.nativeElement.querySelector('.input5');
    inputemail.style.display = 'none';*/
    if (
      this.assistancecase.phone === this.phone &&
      this.assistancecase.phone2 === this.phone2/*&&
      this.assistancecase.address === this.address &&
      this.assistancecase.phone2 === this.phone2 &&
      this.assistancecase.email === this.email_*/
    ) {
      return;
    }

    if (this.assistancecase.phone !== this.phone) {
      const updatephone = Object.assign({}, this.editupdate);
      updatephone.item_name = 'phone';
      updatephone.value_old = this.assistancecase.phone;
      updatephone.value_new = this.phone;
      this.assistancecase.phone = this.phone;
      this.sendupdates.push(updatephone);
    }
    if (this.assistancecase.phone2 !== this.phone2) {
      const updatephone2 = Object.assign({}, this.editupdate);
      updatephone2.item_name = 'phone2';
      updatephone2.value_old = this.assistancecase.phone2;
      updatephone2.value_new = this.phone2;
      this.assistancecase.phone2 = this.phone2;
      this.sendupdates.push(updatephone2);
    }/*
    if (this.assistancecase.address !== this.address) {
      const updateaddress = Object.assign({}, this.editupdate);
      updateaddress.item_name = 'address';
      updateaddress.value_old = this.assistancecase.address;
      updateaddress.value_new = this.address;
      this.assistancecase.address = this.address;
      this.sendupdates.push(updateaddress);
    }

    if (this.assistancecase.email !== this.email_) {
      const updateemail = Object.assign({}, this.editupdate);
      updateemail.item_name = 'email';
      updateemail.value_old = this.assistancecase.email;
      updateemail.value_new = this.email_;
      this.assistancecase.email = this.email_;
      this.sendupdates.push(updateemail);
    }*/
    const modify_data = {
      updates: this.sendupdates,
    };
    this.api.assistanceCasesById
      .putUpdate(this.assistancecase.id, modify_data)
      .promise()
      .then((d) => {
        const updatedata = d[1];
        updatedata.forEach((u) => {
          this.updatecases.unshift(u);
        });
        this.translate
          .get('Assistance case "??" updated', { value: d[0].id })
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: res,
            });
          });
      });
  }

  getMe(): User {
    return this.me.user;
  }

  getAssistanceTicket(): Promise<void> {
    return new Promise((resolve) => {
      this.api.assistancetickets
        .get()
        .all()
        .filter({ case_id: this.case_id })
        .sort('id', true)
        .promise()
        .then(async (t) => {
          this.assistancetickets = t.data;

          this.assistancetickets.forEach(element => {
            if (element.provider_arrival_code != null) {
              this.arrivalcode = element.provider_arrival_code;
            }
          });
          this.loaderService.display(false);

          resolve(); // Disable add service if not exist ticket type 1
          let assignServiceIndex = null;
          assignServiceIndex = _.findIndex(this.assistancetickets, {
            ticket_type: 1,
          });
          if (assignServiceIndex >= 0) {
            this.addService_isDisabled = true;
          }

          let assignProviderIndex = null;
          assignProviderIndex = _.findIndex(this.assistancetickets, {
            ticket_type: 2,
            provider_status: 1,
          });

          let assignProviderTicketIndex = null;
          assignProviderTicketIndex = _.findIndex(this.assistancetickets, {
            ticket_type: 2
          });
          if (assignProviderTicketIndex >= 0) {
            this.ticketProviderExists = true;
          }

          // Markers of map
          this.mapOverlays = [];

          // Origin
          if (this.assistancecase.latitude && this.assistancecase.longitude) {
            this.mapOverlays.push(
              new google.maps.Marker({
                position: {
                  lat: this.assistancecase.latitude,
                  lng: this.assistancecase.longitude,
                },
                title: 'Ubicacion Cliente',
                // label: {
                //   text: "Ubicacion Cliente",
                //   color: "#333333",
                //   fontSize: "1.12rem",
                //   // fontWeight: 'bold',
                //   className: 'custom-marker'
                // },
                icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_provider22.png',
              })
            );
          }
          if (assignProviderIndex >= 0) {
            this.provider = this.assistancetickets[assignProviderIndex].provider;
            this.provider_site_data = this.assistancetickets[assignProviderIndex].provider_site;
            this.provider_id = this.assistancetickets[assignProviderIndex].provider_id;
            this.provider_site_id = this.assistancetickets[assignProviderIndex].provider_site_id;
            this.coverage_id = this.assistancetickets[assignProviderIndex].coverage_id;
          }

          // Destiny
          if (
            this.assistancetickets[assignServiceIndex].latitude &&
            this.assistancetickets[assignServiceIndex].longitude
          ) {
            this.mapOverlays.push(
              new google.maps.Marker({
                position: {
                  lat: this.assistancetickets[assignServiceIndex].latitude,
                  lng: this.assistancetickets[assignServiceIndex].longitude,
                },
                title: 'Ubicacion Destino',
                // label: {
                //   text: "Ubicacion Destino",
                //   color: "#333333",
                //   fontSize: "1.12rem",
                //   // fontWeight: 'bold',
                //   className: 'custom-marker'
                // },
                icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_destiny.png',
              })
            );
          }

          const dbRefAssistanceCases = ref(this.db, 'asistance_cases');
          const childAssistanceCases = child(dbRefAssistanceCases, this.case_id.toString());
          onValue(childAssistanceCases, (snap) => {
            let data = snap.val();
            console.log("Live location data:", data);
            if (data) {
              try {
                if (data.location.latitude == 0 || data.location.longitude == 0) {
                  this.isProviderLiveLocation = false;
                } else {
                  this.isProviderLiveLocation = true;
                }
              } catch (error) {
                console.log(error);
              }
            }

            if (this.mapOverlays.length > 1) {
              try {
                if (data.location.latitude == 0 || data.location.longitude == 0) {
                  this.showroute = false;
                  this.isProviderLiveLocation = false;
                } else {
                  this.showroute = true;
                  this.isProviderLiveLocation = true;
                }
              } catch (error) {
                console.log(error);
              }
              this.mapOverlays.forEach((marker, i) => {
                if (marker.title == 'Ubicacion Proveedor' && data.location) {

                  this.mapOverlays[i] = new google.maps.Marker({
                    position: {
                      lat: data.location.latitude,
                      lng: data.location.longitude
                    },
                    title: "Ubicacion Proveedor",
                    icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_client22.png'
                  });
                  this.fitMap();
                } else if (data && data.location) {
                  this.mapOverlays.push(new google.maps.Marker({
                    position: {
                      lat: data.location.latitude,
                      lng: data.location.longitude
                    },
                    title: "Ubicacion Proveedor",
                    icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_client22.png'
                  }));
                  this.fitMap();
                }
              });

            } else {
              if (assignProviderIndex >= 0 && this.assistancetickets[assignProviderIndex].latitude && this.assistancetickets[assignProviderIndex].longitude) {
                try {
                  if (this.assistancetickets[assignProviderIndex].latitude == 0 || this.assistancetickets[assignProviderIndex].longitude == 0) {
                    this.showroute = false;
                    this.isProviderLiveLocation = false;
                  } else {
                    this.showroute = true;
                    this.isProviderLiveLocation = true;
                  }
                } catch (error) {
                  console.log(error);
                }
                this.mapOverlays.push(new google.maps.Marker({
                  position: {
                    lat: this.assistancetickets[assignProviderIndex].latitude,
                    lng: this.assistancetickets[assignProviderIndex].longitude,
                  },
                  title: "Ubicacion Proveedor",
                  // label: {
                  //   text: "Ubicacion Proveedor",
                  //   color: "#333333",
                  //   fontSize: "1.12rem",
                  //   // fontWeight: 'bold',
                  //   className: 'custom-marker'
                  // },
                  icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_client22.png'
                }));
              }
            }
          });


          this.fitMap();


          this.onSelectService(
            this.assistancetickets[assignServiceIndex].service_id
          );

          this.additionalplanservice = new AssistancePlanService();
          const filter = {
            plan_id: this.plan_id,
            service_id: this.assistancetickets[0].service.id,
          };
          this.api.assistanceplanservices
            .get_extrainfo()
            .filter(filter)
            .promise()
            .then((data) => {
              this.additionalplanservice.emergency_reporting_time =
                data[0].emergency_reporting_time;
              this.additionalplanservice.territoriality = data[0].territoriality;
              this.additionalplanservice.special_condition =
                data[0].special_condition;
              this.additionalplanservice.max_amount = data[0].max_amount;
              this.additionalplanservice.max_amount_general =
                data[0].max_amount_general;
              this.additionalplanservice.sinister_apply = data[0].sinister_apply;
              this.additionalplanservice.buca_apply = data[0].buca_apply
            });

          this.totalCount = t.total;
          this.getservicegroup();
          this.getCategoriesGroup();
        });
    });
  }

  getAssistanceTicketGroup() {
    this.api.assistancetickets
      .get()
      .all()
      .filter({ case_id: this.case_id })
      .sort('id', true)
      .promise()
      .then((t) => {
        this.totalCount = t.total;
      });
  }

  getCategoriesGroup() {
    this.serviceCategories = [];
    for (let i = 0; i < this.servicegroups.length; ++i) {
      const serviceGroup = this.servicegroups[i];

      let categoryName = null;
      if (serviceGroup.service.category && serviceGroup.service.category.name) {
        categoryName = serviceGroup.service.category.name;
      }

      if (this.serviceCategories.indexOf(categoryName) === -1) {
        // Not in array, append
        this.serviceCategories.push(categoryName);
      }
    }
    let cat = this.serviceCategories.filter(category => category === 'Especiales Vial' || category === 'Vial');
    if (cat.length > 0) {
      this.showVial = true;
    }
    try {

      if (this.servicegroups.length > 0 && 'service' in this.servicegroups[0] && this.additionalplanservice && this.additionalplanservice.buca_apply == 1) {
        this.sds_provider = true
        // this.sinister_plan = true
        localStorage.setItem("sds_provider", "1");

      }
      else {
        this.sds_provider = false

      }
      if (this.servicegroups.length > 0 && 'service' in this.servicegroups[0] && this.additionalplanservice && this.additionalplanservice.sinister_apply == 1) {
        // this.sinister_plan = true
        this.sinister_plan_service = true


      } else {
        this.sinister_plan_service = false

      }
    } catch (error) {

      this.sds_provider = false
    }
  }

  getservicegroup() {
    const lasttickets_group = _.uniqBy(this.assistancetickets, 'service_id');
    // for calcul last ticket time flow 5 minutes
    clearInterval(this.editInterval);
    this.groupTimecalcul(lasttickets_group);
    this.ticketpositions = [];
    this.servicegroups = [];
    let closegroup = [];
    let opengroup = [];
    let loopfirst = true;

    // Validate if tickets group have ticket type 1, else return
    let assignServiceGroupIndex = null;
    assignServiceGroupIndex = _.findIndex(this.assistancetickets, {
      ticket_type: 1,
    });
    if (assignServiceGroupIndex < 0) {

      if (
        this.iAm([
          'assistance_admin',
          'supervisor',
          'operator',
          'cabin_agent',
          'networkleader',
          'assistance_dispatcher',
          'assistance_dispatcher_vial',
          'assistance_dispatcher_medical',
        ])
      ) {
        this.startCreateTicket();
      }
      return;
    }

    lasttickets_group.forEach((b) => {
      this.service_id = b.service_id;
      this.api.assistanceservices
        .get_service_by_id({ service_id: this.service_id })
        .promise()
        .then((r) => {
          this.service = r;



          if (this.service.id) {

            const filter = {
              reference_number: this.assistancecase?.id,
              country_id: this.assistancecase?.country?.id,
              sponsor_id: this.assistancecase?.product?.sponsor_id,
              service_id: this.service.id,
              category_id: this.service.category_id,
              contact_channel: this.assistancecase?.contact_channel,
              survey_type: 20 // quemado 20 es para asistencias
            };

            this.api.surveys.exist_evaluate_and_survey_id(filter).promise().then(response => {
              if (response.status == 200) {

                if (response.answered) {
                  this.assistancecase["evaluado"] = true;
                } else {
                  this.assistancecase["evaluado"] = false;
                }

                // element["evaluado"]=false;
                this.assistancecase["survey_id"] = response.survey_id

              } else {
                this.assistancecase["evaluado"] = false; //ya esta evaluado
                this.assistancecase["survey_id"] = -1//no existe id de survey
              }
            })

          }

        })
      if (b.provider_id != null) {
        // this.provider_id = b.provider_id
        // this.provider_site_id = b.provider_site_id
        // this.coverage_id = b.coverage_id
      }
      this.servicegrouptickets[b.service_id] = _.filter(
        this.assistancetickets,
        (a) => a.service_id === b.service_id
      );

      this.servicegrouptickets[b.service_id].forEach(ticket => {
        if (ticket.ticket_type == this.ticketSvc.REIMBURSE) {
          this.hasTicketReimburse = true
        }
      });

      this.servicegrouptickets[b.service_id].forEach(ticket => {
        if (ticket.ticket_type == this.ticketSvc.CABIN_EXCEPTION) {
          this.CabinException = true
        }
      })

      this.servicegrouptickets[b.service_id].forEach(ticket => {
        if (ticket.ticket_type == this.ticketSvc.CABIN_EXCEPTION_AUTHORIZE) {
          this.CabinExceptionAuthorized = true
        }
      })


      // this.servicegrouptickets[b.service_id].forEach((ticket) => {
      //   if (
      //     ticket.ticket_type == this.ticketSvc.ASSIGN_PROVIDER &&
      //     ticket.provider_status == this.PROVIDER_STATUS_TICKET.willGo
      //   ) {
      //     if (ticket.provider_site) {
      //       this.api.assistancetickets
      //         .validateDefaultProviderSite(ticket.provider_site.id)
      //         .promise()
      //         .then((response) => {
      //           this.isDefaultProviderSite = false;
      //           if (response['valid']) {
      //             this.isDefaultProviderSite = true;
      //           }
      //         });
      //     }
      //   }
      // });



      if (this.service_address == null) {
        if (b.address_destination != null) {
          //
          //
          this.service_address = b.address_destination;
          this.showDestinationAddress = true;
        }
      }

      // Start each next ticket type as -1
      this.nextTicketTypes[b.service_id] = -1;

      // Start the listening pending as false
      this.listenActiveIndexes[b.service_id] = false;

      const group = _.cloneDeep(this.servicegrouptickets[b.service_id]);
      // set service group with assign service ticket
      const assisgnserviceticket = group.find((t) => t.ticket_type === 1);
      // when service group have close tickets, move to last position of group
      if (group.find((t) => t.ticket_type === 5)) {
        closegroup.push(assisgnserviceticket);
      } else {
        opengroup.push(assisgnserviceticket);
      }
      // check ticket position has lat, long on groupticket
      this.checkTicketPosition(group);
      // set close button clickable
      this.cancelprovider[b.service_id] = true;
      // show step only first active group
      if (loopfirst) {
        const lastTicket = this.getLastTicketFromGroup(group);

        this.checkStepPending[b.service_id] = true;
      }
      loopfirst = false;

      // check closed ticket in servicegroup
      let close_index = null;
      close_index = _.findIndex(this.servicegrouptickets[b.service_id], {
        ticket_type: 5,
      });

      // By default hide button
      this.ticketbtnshow[b.service_id] = false;
      this.showCancelBtn[b.service_id] = false;
      if (close_index === -1) {
        if (
          this.iAm([
            'assistance_admin',
            'supervisor',
            'operator',
            'operator_cas',
            'cabin_agent',
            'networkleader',
            'assistance_dispatcher',
            'assistance_dispatcher_vial',
            'assistance_dispatcher_medical',
          ])
        ) {
          this.showCancelBtn[b.service_id] = true;
          this.ticketbtnshow[b.service_id] = true;
        }
        // else if (this.iAm(['assistance_dispatcher'])) {
        //   // For this role, allow to create
        //   // Assign provider, provider arrived, canceled by provider, comment
        //   this.listenActiveIndexes[b.service_id] = true;
        //   this.showCancelBtn[b.service_id] = true;
        // }
      }

      // Get latest ticket that provider = will won't in servicegroup
      let wont_index = null;
      wont_index = _.findIndex(this.servicegrouptickets[b.service_id], {
        provider_status: 2,
      });

      let assignServiceIndex = null;
      assignServiceIndex = _.findIndex(this.servicegrouptickets[b.service_id], {
        ticket_type: 1,
      });
      this.providerStartTime[b.service_id] =
        this.servicegrouptickets[b.service_id][assignServiceIndex].datetime;

      // Find notify to customer ticket
      let ntc_index = _.findIndex(this.servicegrouptickets[b.service_id], {
        ticket_type: 16,
      });
      if (ntc_index >= 0) {
        this.notifyToCustomerEndTime[b.service_id] =
          this.servicegrouptickets[b.service_id][ntc_index].datetime;
      }

      // Find if this case is programmed
      let programmed_index = _.findIndex(
        this.servicegrouptickets[b.service_id],
        { ticket_type: 11 }
      );
      if (programmed_index >= 0) {
        this.programedTicketStartTime[b.service_id] =
          this.servicegrouptickets[b.service_id][programmed_index].datetime;
      }

      // Set provider endtime, ArrivalStartTime in servicegroup
      let assignprovider_index = null;
      assignprovider_index = _.findIndex(
        this.servicegrouptickets[b.service_id],
        { ticket_type: 2, provider_status: 1 }
      );
      if (assignprovider_index === null || assignprovider_index <= -1) {
        assignprovider_index = _.findIndex(
          this.servicegrouptickets[b.service_id],
          { ticket_type: 2, provider_status: 3 }
        );
      }
      if (assignprovider_index > -1) {
        if (wont_index === -1 || assignprovider_index < wont_index) {
          this.providerEndTime[b.service_id] =
            this.servicegrouptickets[b.service_id][
              assignprovider_index
            ].datetime;
          this.ArrivalStartTime[b.service_id] =
            this.servicegrouptickets[b.service_id][
              assignprovider_index
            ].datetime;
          this.goprovider[b.service_id] =
            this.servicegrouptickets[b.service_id][
              assignprovider_index
            ].provider;
        } else {
          this.providerEndTime[b.service_id] = null;
          this.ArrivalStartTime[b.service_id] = null;
          this.goprovider[b.service_id] = null;
        }
      } else {
        this.providerEndTime[b.service_id] = null;
        this.ArrivalStartTime[b.service_id] = null;
      }

      // Set arrived endtime and clientEndTime in servicegroup
      let arrival_index = null;
      arrival_index = _.findIndex(this.servicegrouptickets[b.service_id], {
        ticket_type: 4,
        provider_status: 1,
      });
      if (arrival_index === null || arrival_index <= -1) {
        arrival_index = _.findIndex(this.servicegrouptickets[b.service_id], {
          ticket_type: 4,
          provider_status: 3,
        });
      }
      if (arrival_index > -1) {
        if (arrival_index < assignprovider_index) {
          this.ArrivalEndTime[b.service_id] =
            this.servicegrouptickets[b.service_id][arrival_index].datetime;
          this.clientEndTime[b.service_id] =
            this.servicegrouptickets[b.service_id][arrival_index].datetime;
        } else {
          this.ArrivalEndTime[b.service_id] = null;
          this.clientEndTime[b.service_id] = null;
        }
      } else {
        this.ArrivalEndTime[b.service_id] = null;
        this.clientEndTime[b.service_id] = null;
      }

      if (close_index > -1) {
        if (!this.providerEndTime[b.service_id]) {
          this.providerEndTime[b.service_id] =
            this.servicegrouptickets[b.service_id][close_index].datetime;
        }
        if (!this.ArrivalEndTime[b.service_id]) {
          this.ArrivalEndTime[b.service_id] =
            this.servicegrouptickets[b.service_id][close_index].datetime;
        }
        if (!this.clientEndTime[b.service_id]) {
          this.clientEndTime[b.service_id] =
            this.servicegrouptickets[b.service_id][close_index].datetime;
        }
      }

      if (this.case_status == 2) {
        if (!this.providerEndTime[b.service_id]) {
          this.providerEndTime[b.service_id] = this.case_end_date;
        }
        if (!this.ArrivalEndTime[b.service_id]) {
          this.ArrivalEndTime[b.service_id] = this.case_end_date;
        }
        if (!this.clientEndTime[b.service_id]) {
          this.clientEndTime[b.service_id] = this.case_end_date;
        }
      }
    });

    this.servicegroups = opengroup.concat(closegroup);

    this.servicegrouptickets[this.service_id].forEach(element => {

      let comm = element['comment']
      if (comm != "" && comm != null) {

        if (element['comment'].includes('Caso y ticket generado desde la app de asistencia')
          || element['comment'].includes('Notificacion automatica por utilizar la app de asistencia')) {
          localStorage.setItem(this.assistancecase.id.toString(), '1');
        }
        try {
          const comms = JSON.parse(comm);

          if (typeof comms === 'object') {
            element.comment = comms.comment
          }
        } catch (error) {
          element.comment = comm
        }
      }
      if (element['ticket_type'] === this.ASSISTANCE_TICKET_TYPE) {
        this.last_provider_national_id = element['user']['national_id']
      }
    });
    if (
      this.totalCount === 0 &&
      this.iAm([
        'assistance_admin',
        'supervisor',
        'operator',
        'cabin_agent',
        'networkleader',
        'assistance_dispatcher',
        'assistance_dispatcher_vial',
        'assistance_dispatcher_medical',
      ])
    ) {
      this.startCreateTicket();
    }
  }

  cleanDate(date) {
    let date_info = date.split('T');
    return date_info[0] + ' ' + date_info[1];
  }

  groupTimecalcul(groups) {
    this.editInterval = setInterval(() => {
      const date2 = new Date();
      const date2_ms =
        date2.getTime() + (date2.getTimezoneOffset() * 3600 * 1000) / 60; //current UTC
      groups.forEach((b) => {
        const date1 = new Date(b.datetime);
        const date1_ms = date1.getTime();
        // Calculate the difference in milliseconds
        const difference_ms = date2_ms - date1_ms;
        // take out seconds
        const difference_second = difference_ms / 1000;
        if (difference_second < 300) {
          this.editbtnshow[b.service_id] = true;
        } else {
          this.editbtnshow[b.service_id] = false;
        }
      });
    }, 1000);
  }

  prevPage() {
    this.page -= 1;
    this.getAssistanceTicket();
  }

  getProviderInfo() {

    this.LoaderService.display(true)

    this.api.assistanceProvidersById.get(this.provider_id).promise().then(resp => {
      this.provider2 = resp
    })
      .catch(e => {

        this.LoaderService.display(false)
      });

    this.api.assistanceProviders.getAssistanceProviderSiteItem(this.provider_id, this.provider_site_id).promise().then(resp2 => {
      this.provider_site = resp2.content[0];
    })
      .catch(e => {

        this.LoaderService.display(false)
      });

    this.api.assistanceProviders.getAssistanceProviderCoverageItem(this.provider_site_id, this.coverage_id).promise().then(resp3 => {
      this.coverage = resp3.content[0];
    })
      .catch(e => {

        this.LoaderService.display(false)
      });

    this.api.assistancePricesProvidersByIdservicesById.get(this.provider_id, this.provider_site_id, this.coverage_id, this.service_id).promise()
      .then(price => {
        this.prices = price;
      })
      .catch(e => {

        this.LoaderService.display(false)
      });
    let unassigned = true;
    this.servicegroups.forEach(servicegroup => {
      this.servicegrouptickets[servicegroup.service_id].forEach(ticket => {

        if (ticket.ticket_type == 2 && ticket.provider_status == 1) {
          unassigned = false
        }
      });
    });
    if (unassigned == true) {
      this.showUnassignedModal = true;
      this.unAssignedProvider = true;
    }
    else {
      this.showUnassignedModal = false;
      this.unAssignedProvider = false;
    }
    this.LoaderService.display(false)
  }

  openLinkLocationCustomer() {
    let url = `https://www.google.com/maps/place/${this.caseLocation.latitude},${this.caseLocation.longitude}`;
    this.api.copyToClipboard(url);
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Link de la localización del cliente copiado al portapapeles.',
    });
    // window.open(url, "_blank");
  }

  async ReassignProvider(servi: any) {
    let providers_rea
    //this.country.emit(this.assistancecase.country.id)
    this.service2.emit(servi)


    //
    // let groups = this.servicegrouptickets[servi]
    // const realgroup = this.filtergroups(groups);
    // let lastTicket: AssistanceTicket;
    // lastTicket = realgroup.shift();
    const filter = {
      //country_id: this.assistancecase.country.id,
      service_id: servi,
      status: 1
    };
    this.showReassignProviderDialog = true
    // this.reassignTicket.emit({Ticket: lastTicket});
    try {
      //  await ( this.api.assistanceProviders.getre().filter(filter).promise()
      // await ( await this.api.assistance_case_providers.get(this.case_id, { "all": true }).promise()
      await (await this.api.assistanceProvicerSites.get(this.assistancecase.country_id, this.service_id).promise()
        .then(res => {
          let data = res.data


          providers_rea = data;
          this.providers_re.emit(providers_rea)
        }))
    } catch (exception) {


    }
  }

  showProviderCard() {
    /*this.case_provider_id.emit(this.provider_id)
    this.case_provider_site_id.emit(this.provider_site_id)
    this.case_coverage_id.emit(this.coverage_id)
    this.case_service_id.emit(this.service_id)
    this.showProviderDialog = true;*/
    this.showProviderView = true;
    this.showDialogGeneral = false;
    this.flagAssignProvider = true;
    this.getProviderInfo();

  }
  hideletter() {
    this.showDialogGeneral = true;
    this.showletter = false
    this.showletter2 = false
    this.showletter3 = false;
    this.showletter4 = false
    this.showletter5 = false;
  }

  hideeditmanual() {
    this.showDialogGeneral = true;
    this.showeditManual = false
    window.location.reload()
  }
  hideProviderCard() {
    this.showProviderView = false;
    this.showDialogGeneral = true;
    this.flagAssignProvider = false;
  }

  showCaseCard() {
    this.showCaseFormDialog = true;
    this.editevent.emit();
  }

  showCaseCardInfo() {
    this.showCaseFormDialogTicketInfo = true;
    this.editevent.emit();
  }

  getBucaCodes() {


    this.case_buca_id.emit(this.case_id)
    this.showBucaCodesDialog = true;
  }

  hideBucaCodesDialog() {
    this.showBucaCodesDialog = false;
  }

  nextPage($event) {
    this.page = $event.page + 1;
    this.getAssistanceTicket();
  }

  onCancelEdit() {
    this.showCommentDialog = false;
    this.showCourtesyDialog = false;
    this.showCommentUserDialog = false;
    //this.showEditDialog = false;
    this.showBillFormDialog = false;
    this.cancelDialog = false;
    this.showCreateDialog = false;
    this.serviceConfiguration = false;
    this.showExceptionDialog = false;
  }
  onCancelEdit2() {
    this.its_free = false;
    this.showCommentUserDialog = false;
    this.showCourtesyDialog = false;
    //this.showEditDialog = false;
    this.showBillFormDialog = false;
    this.cancelDialog = false;
    this.showCreateDialog = false;
    this.serviceConfiguration = false;
    this.showExceptionDialog = false;
  }
  startCreateTicket() {
    // this.showCreateDialog = true;
    // this.createTicket.emit();
  }

  // Filter tickets type=comment(9) from groups
  filtergroups(groups: any) {
    let grouptickets: any[] = [];
    grouptickets = groups;
    grouptickets = _.filter(
      grouptickets,
      (a) =>
        a.ticket_type !== 12 &&
        a.ticket_type !== 22 &&
        a.ticket_type !== 6 &&
        a.ticket_type !== 7 &&
        a.ticket_type !== 23 &&
        a.ticket_type !== 8 &&
        a.ticket_type !== 9 &&
        a.ticket_type !== 10 &&
        a.ticket_type !== 11 &&
        a.ticket_type !== 14 && // exception
        a.ticket_type !== 15 && // exception
        a.ticket_type !== 16 && // notify to customer
        a.ticket_type !== 17 && // assign / unassign user
        a.ticket_type !== 18 &&
        a.ticket_type !== 19 &&
        a.ticket_type !== 35 &&
        a.ticket_type !== 50 &&
        a.ticket_type !== 30 &&
        a.ticket_type !== 60 &&
        a.ticket_type !== 36
    );
    return grouptickets;
  }

  startCreategroupTicket(groups: any) {
    this.newticket = false;
    this.isDisabled.emit(false);
    // Copy array to pop elemen without deleting the element from the list
    const copyGroup = _.cloneDeep(groups);
    const lastTicket = this.getLastTicketFromGroup(copyGroup);
    this.checkstep(lastTicket);
  }

  alreadyHasProvider(group: any) {
    const copyGroup = _.cloneDeep(group);
    const lastTicket = this.getLastTicketFromGroup(copyGroup);
    if (
      lastTicket.provider_id &&
      lastTicket.provider_status == this.ticketSvc.PROVIDER_STATUS_WILL_GO
    ) {
      return true;
    } else if (lastTicket.provider_status == this.ticketSvc.PROVIDER_TEMP) {
      return true;
    } else {
      return false;
    }
  }

  onCreateCartaPorte(group: any) {
    // Show bill form without showing the closing form
    if (this.canCreateBill()) {
      const copyGroup = _.cloneDeep(group);
      const lastTicket = this.getLastTicketFromGroup(copyGroup);
      this.fromBillCreationClose = false;
      this.arrivedTicket.emit(lastTicket);
      this.cartaPorte.emit(true);
      //this.showEditDialog = true;
      this.showDialogGeneral = false;
      this.showProgramedService = false;
      this.showExceptionDialog = false;
      this.showBillFormDialog = true;
    }
  }

  goBackBillForm() {
    if (this.createbillComponent.showComplementCartaPorte == true) {
      this.createbillComponent.backToGeneralBillInformation();
    } else {
      this.showBillFormDialog = false;
      this.showDialogGeneral = true;
      this.showProgramedService = false;
      this.showExceptionDialog = false;
      this.billsformreset();
    }
  }

  onLoadPrice(price: any) {
    this.billprice = _.cloneDeep(price);
    if (this.billprice.max_amount === null) {
      this.billprice.max_amount = 0;
    }
  }

  onBillCreate(data: any) {
    if (this.additionalplanservice && this.additionalplanservice.buca_apply == 1 && this.assistancecase?.assistance_sale?.category == 'BUCA INSURANCE') {
      this.ticketMessage({ 'severity': 'error', 'summary': 'Error', 'detail': 'El cierre del servicio se hará desde el portal BUCA por ser un caso de BUCA.' })
      this.onBillCreateCancel();
      return;
    }

    this.messageService.clear();
    this.confirmticket = data.ticket;
    this.confirmbill = data.bill;
    if (
      this.confirmticket.ticket_type === this.ticketSvc.PROVIDER_ARRIVED ||
      this.confirmticket.ticket_type === this.ticketSvc.CANCELED_BY_PROVIDER ||
      this.confirmticket.ticket_type === this.ticketSvc.CANCELED_BY_SUPERVISOR ||
      this.confirmticket.ticket_type === this.ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT ||
      this.confirmticket.ticket_type === this.ticketSvc.CANCELED_BY_CLIENT ||
      this.confirmticket.ticket_type === this.ticketSvc.CANCELED_BY_CLIENT_WITHOUT_COST
    ) {
      if (this.confirmbill.price_agreed > this.billprice.max_amount) {
        let id_service = data.ticket.service
        // 
        // 
        // 

        if (this.serviceCategories[0] === "Médica" || id_service.id === 428 || id_service.id === 429 || id_service.id === 423) {   //3. es medica
          // 
          this.showSupervisorDialog = false;
          this.createNewBill(this.confirmbill, this.confirmticket);
        } else {
          // 
          this.showSupervisorDialog = true;
        }
      } else {
        this.createNewBill(this.confirmbill, this.confirmticket);
      }
    } else {
      this.createNewBill(this.confirmbill, this.confirmticket);
    }

    //this.showEditDialog = false;
    // this.showBillFormDialog = false;
    // this.onBillCreateCancel();
  }

  billsformreset() {
    this.createbillComponent.reset();
  }

  confirmSupervisor() {
    this.isdisabled_confirm = true;
    this.loaderService.display(false);
    this.api.authToken
      .post({
        email: this.supervisor.email,
        password: this.supervisor.password,
      })
      .params({ keep_session: true })
      .promise()
      .then((token) => {
        this.me.setToken(token.token);
      })
      .then(() => this.api.me.get().promise())
      .then((supervisor) => {
        this.me.updateToken(supervisor);
        this.isdisabled_confirm = false;
        this.loaderService.display(false);
        if (
          supervisor.roles.indexOf('admin') !== -1 ||
          supervisor.roles.indexOf('assistance_admin') !== -1 ||
          supervisor.roles.indexOf('supervisor') !== -1
        ) {
          this.showSupervisorDialog = false;
          this.showwarinningmessage = false;
          this.createNewBill(this.confirmbill, this.confirmticket);
        } else {
          this.showSupervisorDialog = true;
          this.showwarinningmessage = true;
        }
      })
      .catch((e) => {
        this.isdisabled_confirm = false;
        this.loaderService.display(false);
        this.showSupervisorDialog = true;
        this.showwarinningmessage = true;
      });
  }

  onCancelSupervisor() {
    this.isDisabled.emit(false);
    this.isdisabled_confirm = false;
    this.showSupervisorDialog = false;
    this.showwarinningmessage = false;
    this.supervisor.email = null;
    this.supervisor.password = null;
  }

  createNewBill(bill, ticket) {
    this.loaderService.display(true);

    if (bill.carta_porte_data) {
      this.api.assistancebills
        .post_carta_porte(bill)
        .promise()
        .then((b) => {
          this.isDisabled.emit(false);
          this.loaderService.display(false);
          this.cancelprovider[ticket.service_id] = true;
          this.tieneCartaPorte = true;
          this.translate
            .get('New assistance bill created')
            .subscribe((res: string) => {
              this.messageService.add({
                severity: 'info',
                summary: 'Info',
                detail: res,
              });
            });
          this.onBillCreateCancel();
        })
        .catch((e) => {
          let error_msg;
          try {
            error_msg = JSON.parse(e.error.error);
            error_msg = `${error_msg.message}. Error código ${error_msg.code}`;
          } catch (e2) {
            error_msg = e.error;
          }

          this.isDisabled.emit(false);
          this.loaderService.display(false);
          this.translate
            .get('Error creating new assistance bill')
            .subscribe((res: string) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: `${res}: ${error_msg}`,
              });
            });
          this.onBillCreateCancel();
        });
    } else {
      this.api.assistancebills
        .post(bill)
        .promise()
        .then((b) => {
          this.isDisabled.emit(false);
          this.loaderService.display(false);
          this.cancelprovider[ticket.service_id] = true;
          this.translate
            .get('New assistance bill created')
            .subscribe((res: string) => {
              this.messageService.add({
                severity: 'info',
                summary: 'Info',
                detail: res,
              });
            });
          this.onBillCreateCancel();
          // if (ticket.ticket_type === this.ticketSvc.PROVIDER_ARRIVED) {
          this.autocloseCase(ticket);
          // }

          // DESCOMENTAR TAREA EMILIA
          // const payload = {'country_id': this.assistancecase.country.id, 'service_id': this.service.id};

          // this.api.country_service.getById(payload).promise()
          //   .then(resp => {
          //     this.sendEmailCommunication.saving = resp.price;

          //     this.sendEmailCommunication.member_name = this.assistancecase?.member?.name;
          //     this.sendEmailCommunication.plan = this.assistancecase?.plan?.name;
          //     this.sendEmailCommunication.product = this.assistancecase?.product?.name;
          //     this.sendEmailCommunication.service = this.service?.name;
          //     this.sendEmailCommunication.phone_number = this.phone;
          //     this.sendEmailCommunication.email = this.assistancecase?.member?.email != undefined ? this.assistancecase?.member?.email : "";

          //     this.api.assistanceplans.sendEmailCommunication(this.assistancecase?.plan?.id.toString(),this.assistancecase?.member.id,this.sendEmailCommunication).promise()
          //       .then(rsp=>{
          //         
          //       })
          //       .catch(err=>{
          //         
          //       })
          //   }); 
        })
        .catch((e) => {
          let error_msg = e.error;
          try {
            error_msg = e.error.error;
            this.translate
              .get(error_msg)
              .subscribe((res: string) => {
                error_msg = res;
              });
          } catch {
            error_msg = e.error;
          }
          this.isDisabled.emit(false);
          this.loaderService.display(false);
          this.translate
            .get('Error creating new assistance bill')
            .subscribe((res: string) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: `${res}: ${error_msg}`,
              });
            });
          this.onBillCreateCancel();
        });
    }
  }

  onCancelCreate(cancel_ticket_data: any) {
    let creatticket = cancel_ticket_data.ticket;

    if (cancel_ticket_data.ticket.ticket_type == 23 && !this.assistancecase.reimbursement_amount) {
      this.showreimbursementalert = true;
      this.isDisabled.emit(false);
      return;
    }

    // Close the case when create ticket cancel
    // If this case applies to Dead service, prevent to autoclose to generate bill
    this.close_ticket_on_cancel = true;
    // if (cancel_ticket_data.is_dead_service == true) {
    //   this.close_ticket_on_cancel = false;
    // }

    this.onTicketCreate(creatticket);
  }

  onBillCreateCancel() {
    //this.showEditDialog = false;
    this.showBillFormDialog = false;
    this.showDialogGeneral = true;
    this.showProgramedService = false;
    this.billsformreset();
  }

  checkTicketPosition(group1) {
    // this is for map route data
    let group = _.cloneDeep(group1);
    group = group.reverse();
    /* 
     */

    const assign_ticket = group.find(
      (t) => t.ticket_type === 1 && t.latitude && t.longitude
    );
    if (assign_ticket) {
      this.ticketpositions.push({
        lat: this.assistancecase.latitude,
        lng: this.assistancecase.longitude,
        name: assign_ticket.service.name,
        type: 'origin',
        service_name: assign_ticket.service.name,
      });



      if (
        this.assistancecase.destination_longitude != null &&
        this.assistancecase.destination_latitude != null
      ) {
        this.ticketpositions.push({
          lat: this.assistancecase.destination_latitude,
          lng: this.assistancecase.destination_longitude,
          name: 'destino: ' + this.service_address,
          type: 'destination',
          service_name: 'destino',
        });
        /*  */
      }
    }
    let cancelation = false;
    const cancel_index = _.findLastIndex(group, { ticket_type: 8 });
    const last_index = _.findLastIndex(group, {
      ticket_type: 2,
      provider_status: 1,
    });
    let provider_ticket = null;
    if (last_index > -1) provider_ticket = group[last_index];

    if (
      cancel_index > -1 &&
      last_index > -1 &&
      group[cancel_index].provider_id === group[last_index].provider_id
    )
      cancelation = true;

    /* if (provider_ticket && provider_ticket.latitude && provider_ticket.longitude && !cancelation ) {
      this.ticketpositions.push({lat: provider_ticket.latitude, lng: provider_ticket.longitude,
      name: provider_ticket.provider.name, type: 'provider', service_name: provider_ticket.service.name});
    } */

    /* if(this.providerAppLocation.latitude != null){
      this.ticketpositions.push({
        lat: this.providerAppLocation.latitude,
        lng: this.providerAppLocation.longitude,
        name: "proveedor",
        type: 'providerApp',
        service_name: "proveedor asignado"});
    } */

    if (this.assistancecase.latitude && this.assistancecase.longitude) {
      this.showroute = true; this.isClientLocation = true;
    }
    else { this.showroute = false; this.isClientLocation = false; }
  }

  checkstep(ticket: AssistanceTicket) {
    console.log('ticket ')
    console.log(ticket)
    const connectstate = this.servicegrouptickets[ticket.service_id].find(
      (t) => t.ticket_type === 12
    );

    if (
      ticket.ticket_type === this.ticketSvc.PROVIDER_ARRIVED &&
      ticket.provider_status === this.ticketSvc.PROVIDER_STATUS_WILL_GO
    ) {
      this.disableallstep.emit();
      this.messageService.clear();
      if (connectstate) {
        this.showstep[ticket.service_id] = false;
      }
      this.showstep[ticket.service_id] = false;

      this.canCloseTicket(ticket);
    } else if (
      (ticket.ticket_type === 6 ||
        ticket.ticket_type === 7 ||
        ticket.ticket_type === 23 ||
        ticket.ticket_type ===
        this.ticketSvc.CANCELED_BY_CLIENT_WITHOUT_COST) &&
      !connectstate
    ) {
      let group = _.cloneDeep(this.servicegrouptickets[ticket.service_id]);
      group = group.reverse();
      const last_index = _.findLastIndex(group, {
        ticket_type: 2,
        provider_status: 1,
      });
      let provider_ticket = null;
      if (last_index > -1) {
        provider_ticket = group[last_index];
        const seconds =
          (new Date(ticket.datetime).getTime() -
            new Date(provider_ticket.datetime).getTime()) /
          1000;
        this.api.assistancePricesProvidersByIdservicesById
          .get(
            ticket.provider_id,
            ticket.provider_site_id,
            ticket.coverage_id,
            ticket.service_id
          )
          .promise()
          .then((price) => {
            if (price.price_cancellation > 0 && seconds > 600) {
              const filter = {
                case_id: this.assistancecase.id,
                service_id: ticket.service_id,
                provider_id: ticket.provider_id,
              };
              this.api.assistancebills
                .get()
                .filter(filter)
                .promise()
                .then((bills) => {
                  if (bills.total > 0) {
                    this.cancelprovider[ticket.service_id] = true;
                    this.setShowStepTrue(ticket.service_id);
                    this.typesService.sendServiceID(ticket.service_id);
                  } else {
                    this.cancelprovider[ticket.service_id] = false;
                    this.showstep[ticket.service_id] = false;
                    this.messageService.clear();
                    this.disableallstep.emit();
                    // Show bill form without showing the closing form
                    if (this.canCreateBill()) {
                      this.fromBillCreationClose = false;
                      this.arrivedTicket.emit(ticket);
                      //this.showEditDialog = true;
                      this.showBillFormDialog = true;
                      this.showDialogGeneral = false;
                      this.showProgramedService = false;
                      this.showExceptionDialog = false;
                    }
                  }
                });
            } else {
              this.setShowStepTrue(ticket.service_id);
              this.typesService.sendServiceID(ticket.service_id);
            }
          });
      }
    } else if (ticket.ticket_type === 5 || ticket.ticket_type === 9) {
      this.showstep[ticket.service_id] = false;
      return;
    } else {
      this.setShowStepTrue(ticket.service_id);
      this.typesService.sendServiceID(ticket.service_id);
    }
  }

  autoStepshow(ticket: AssistanceTicket, step3flag) {
    this.getCategoriesGroup();
    this.getservicegroup();
  }

  closeTicket(id, groups: any) {
    const realgroup = this.filtergroups(groups);
    let lastTicket: AssistanceTicket;
    lastTicket = realgroup[0];
    this.alertConfirm(lastTicket);
  }

  stopTimerCustomer(id, groups: any) {
    let result = confirm(
      '¿Desea detener el tiempo para notificación al cliente de este servicio?'
    );

    if (result) {
      let ticket: AssistanceTicket;
      ticket = _.cloneDeep(groups[0]);
      ticket.ticket_type = 16; // Notify to customer
      ticket.comment = '';
      this.onTicketCreate(ticket);
    }
  }

  alertConfirm(lastTicket: AssistanceTicket) {
    this.newticket = false;
    this.groupservicename = lastTicket.service.name;
    this.closedticket = lastTicket;
    const startTime = new Date(this.assistancecase.date_start).getTime();
    const entTime =
      new Date().getTime() +
      (new Date().getTimezoneOffset() * 3600 * 1000) / 60;
    const intervalTime = Math.floor((entTime - startTime) / 1000 / 60);
    if (intervalTime > 30) {
      this.alertDialog = true;
    } else {
      this.canCloseTicket(lastTicket);
    }
  }

  sendNPSbyEmail(ticket) {



    const filter = {
      case_id: this.case_id,
      service_id: this.assistancetickets[0].service.id,
    };
    this.api.assistancecases
      .sendNPS()
      .filter(filter)
      .promise()
      .then((assistanceCase) => {
        Object.assign(this.assistancecase, assistanceCase);
        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Encuesta NPS enviada',
        });
      })
      .catch((e) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error enviando encuesta NPS',
        });
      });
  }

  //---enviar correo de alerta
  sendAlertEmail() {


    this.api.assistancecases
      .sendAlertEmail(this.assistancecase.id)
      .promise()
      .then((assistanceCase) => {

        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Correo de alerta enviado',
        });
      })
      .catch((e) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error enviando el correo de alerta',
        });
      });
  }


  billDialogBeforeClose(ticket) {
    // If it is by connection don't show the bill form
    const byConnection = this.servicegrouptickets[ticket.service_id].find(
      (t) => t.ticket_type === this.ticketSvc.CONNECTION
    );

    // Only enable billing if provider site has enabled apply_billing check
    let applyBilling = false;
    if (this.provider && this.provider_site_data) {
      applyBilling = this.provider_site_data.apply_billing;
    }

    if (!byConnection && applyBilling && (this.additionalplanservice && this.additionalplanservice.buca_apply != 1)) {
      // Get the current step, if not on right step shouldn't create bill

      const cancelled_ticket = this.servicegrouptickets[ticket.service_id].find(
        (t) => {
          return (
            t.ticket_type === this.ticketSvc.CANCELED_BY_CLIENT ||
            t.ticket_type === this.ticketSvc.CANCELED_BY_CLIENT_WITHOUT_COST ||
            t.ticket_type === this.ticketSvc.CANCELED_BY_PROVIDER ||
            t.ticket_type === this.ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT ||
            t.ticket_type === this.ticketSvc.CANCELED_BY_SUPERVISOR
          )
        }
      );

      const ticketType = this.translateActiveIndexToTicketType(
        this.stepComponent.activeIndex
      );

      // if(this.assistancecase.ticket.service_id == 479 && this.assistancecase.product.name =='Honduras Tropigas'){
      //   

      //   ticketType = this.translateActiveIndexToTicketType2(
      //     this.step2Component.activeIndex 
      //     );
      // }else{ticketType = this.translateActiveIndexToTicketType(
      //   this.stepComponent.activeIndex 
      //   );
      // }

      if (ticketType == -1 || ticketType == this.ticketSvc.ASSIGN_SERVICE) {
        // If service on right step 
        const filter = {
          case_id: this.assistancecase.id,
          service_id: ticket.service_id,
          provider_id: ticket.provider_id,
        };
        this.api.assistancebills
          .get()
          .filter(filter)
          .promise()
          .then((bills) => {
            this.showstep[ticket.service_id] = false;
            if (bills.total > 0) {
              this.autocloseCase(ticket);
            } else {
              // No bills for the case

              if (cancelled_ticket && cancelled_ticket.provider_id != ticket.provider_id) {
                this.arrivedTicket.emit(ticket || cancelled_ticket);
              } else {
                this.arrivedTicket.emit(cancelled_ticket || ticket);
              }

              //this.showEditDialog = true;
              this.showDialogGeneral = false;
              this.showProgramedService = false;
              this.showExceptionDialog = false;
              this.showBillFormDialog = true;
            }
          });

        return;
      }
    }

    return this.autocloseCase(ticket);
  }

  autocloseCase(ticket: AssistanceTicket) {
    this.alertDialog = false;
    const groups = _.filter(
      this.servicegroups,
      (a) => a.service_id !== ticket.service_id
    );
    let close_index: number = null;
    // Find closed service group
    for (let i = 0, len = groups.length; i < len; i++) {
      close_index = _.findIndex(
        this.servicegrouptickets[groups[i].service_id],
        { ticket_type: 5 }
      );
      if (close_index === -1) {
        break;
      }
    }
    if (close_index !== -1) {
      this.ticketbtnshow[ticket.service_id] = false;
      this.assistancecase.status = 2;
      this.api.assistancecases
        .close(this.assistancecase.id)
        .promise()
        .then((c) => {
          this.router.navigate([
            'admin/assistance-v1/cases',
            this.assistancecase.id,
            'bills',
            2,
          ]);
        });
    } else {
      this.stepComponent.closeticket(ticket);
    }
  }

  setComment(groups: any) {
    let lastTicket: AssistanceTicket;
    lastTicket = _.cloneDeep(groups[0]);

    // Set ticket type to comment 9
    lastTicket.ticket_type = 9;

    this.editcommentflag = false;
    this.commentTicket.emit({ Ticket: lastTicket, Case: false });
    this.showCommentDialog = true;
  }

  onQuotationComment(quotationData: any) {
    // Crear un ticket de comentario con la información de la cotización
    let quotationTicket: AssistanceTicket = new AssistanceTicket();

    // Construir el comentario completo con información del provider y coverage
    let fullComment = quotationData.comment;

    if (quotationData.providerInfo) {
      fullComment += `\n\n${quotationData.providerInfo}`;
    }

    if (quotationData.coverageInfo) {
      fullComment += `\n${quotationData.coverageInfo}`;
    }

    // Configurar el ticket como comentario de cotización
    quotationTicket.ticket_type = 9; // Tipo comentario
    quotationTicket.comment = fullComment;
    quotationTicket.service_id = this.service_id;
    quotationTicket.case_id = this.assistancecase.id;

    // Emitir el evento para mostrar el diálogo de comentario
    this.editcommentflag = false;
    this.commentTicket.emit({ Ticket: quotationTicket, Case: false });
    this.showCommentDialog = true;
  }

  setCourtesy(groups: any) {
    let lastTicket: AssistanceTicket;
    lastTicket = _.cloneDeep(groups[0]);

    // Set ticket type to comment 9
    lastTicket.ticket_type = 22;

    this.editcommentflag = false;
    this.commentTicket.emit({ Ticket: lastTicket, Case: false });
    this.showCourtesyDialog = true;
  }

  editComment(ticket: AssistanceTicket) {
    this.editcommentflag = true;
    this.commentTicket.emit({ Ticket: ticket, Case: true });
    this.showCommentDialog = true;
  }

  editDate() {
    this.modifyDate = true;
  }

  onSetScheduleAppointment() {

    this.loaderService.display(true);
    this.api.assistancecases.update_appointment_date({ case_id: this.case_id.valueOf(), appointment_date: this.appointment_date }).promise()
      .then((result) => {
        this.loaderService.display(false);
        this.assistancecase.appointment_date = result.appointment_date
        let lastTicket: AssistanceTicket;
        lastTicket = _.cloneDeep(this.servicegrouptickets[this.servicegroups[0].service_id][0]);
        lastTicket.ticket_type = 9;
        let appointment_date = new Date(this.assistancecase.appointment_date + 'Z')
        appointment_date.setHours(appointment_date.getHours() + this.hourTimeZone);
        let date = appointment_date.toISOString().split('T')
        let daynhour = date[0] + ' ' + date[1].slice(0, 8)
        lastTicket.comment = `Cita programada para el: ${daynhour}`;

        this.onTicketCreate(lastTicket);
        this.show_schedule_appointment = false
      })
      .catch((e) => {
        this.loaderService.display(false);
        this.translate
          .get('Error Schedule Appointment')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.error}`,
            });
          });
      });
  }

  showScheduleApooinment() {
    this.show_schedule_appointment = true;
  }

  formcartaau(op: number, groups: any) {

    this.showDialogGeneral = false;

    if (op == 1) {
      this.applicant_name.emit(this.assistancecase.applicant_name);

      this.applicant_id.emit(this.assistancecase.member.national_id);
      this.country.emit(this.assistancecase.country.id);
      const realgroup = this.filtergroups(groups);
      let lastTicket: AssistanceTicket;
      lastTicket = realgroup.shift();


      if (lastTicket.provider) {

        let cost = lastTicket.coverage.assistancePrices.filter((e) => e.service_id == lastTicket.service_id)
        if (!this.assistancecase.appointment_date) {
          this.assistancecase.appointment_date = moment().add(this.hourTimeZone * -1, 'hours').format("YYYY-MM-DDTHH:mm:ss");
        }
        let appointment_date = new Date(this.assistancecase.appointment_date + 'Z')


        appointment_date.setHours(appointment_date.getHours() + this.hourTimeZone);


        let provider_info = {
          'name': lastTicket.provider.name,
          'address': lastTicket.provider_site.address,
          'cost': cost[0].price_weekday,
          "date": appointment_date.toISOString(),
          'by_connection': this.findByConnectionTicket()
        }
        this.provider_letter = provider_info
      }

      this.showletter = true;
      this.showletter2 = false;
      this.showletter3 = false;
      this.showletter4 = false;
      this.showletter5 = false;
    } else if (op == 2) {
      this.applicant_name.emit(this.assistancecase.applicant_name);

      this.applicant_id.emit(this.assistancecase.member.national_id);
      this.country.emit(this.assistancecase.country.id);
      //this.showletterdiscount = true
      const realgroup = this.filtergroups(groups);
      let lastTicket: AssistanceTicket;
      lastTicket = realgroup.shift();


      if (lastTicket.provider) {

        let cost = lastTicket.coverage.assistancePrices.filter((e) => e.service_id == lastTicket.service_id)
        if (!this.assistancecase.appointment_date) {
          this.assistancecase.appointment_date = moment().add(this.hourTimeZone * -1, 'hours').format("YYYY-MM-DDTHH:mm:ss");
        }

        let appointment_date = new Date(this.assistancecase.appointment_date + 'Z')
        appointment_date.setHours(appointment_date.getHours() + this.hourTimeZone);
        let provider_info = {
          'name': lastTicket.provider.name,
          'address': lastTicket.provider_site.address,
          'cost': cost[0].price_weekday,
          "date": appointment_date.toISOString(),
          'by_connection': this.findByConnectionTicket()
        }
        this.provider_letter = provider_info
      }

      this.showletter2 = true;
      this.showletter = false;
      this.showletter3 = false;
      this.showletter4 = false;
      this.showletter5 = false;
    } else if (op == 3) {
      this.applicant_name.emit(this.assistancecase.applicant_name);

      this.applicant_id.emit(this.assistancecase.member.national_id);
      this.country.emit(this.assistancecase.country.id);
      this.showlettercopago = true;
      this.observation_copago =
        'Se le recuerda que el precio preferencial/participación del afiliado deberá ser cancelado al momento de recibir el servicio.';

      const realgroup = this.filtergroups(groups);
      let lastTicket: AssistanceTicket;
      lastTicket = realgroup.shift();

      if (lastTicket.provider) {

        let cost = lastTicket.coverage.assistancePrices.filter((e) => e.service_id == lastTicket.service_id)
        if (!this.assistancecase.appointment_date) {
          this.assistancecase.appointment_date = moment().add(this.hourTimeZone * -1, 'hours').format("YYYY-MM-DDTHH:mm:ss");
        }
        let appointment_date = new Date(this.assistancecase.appointment_date + 'Z')


        appointment_date.setHours(appointment_date.getHours() + this.hourTimeZone);


        let provider_info = {
          'name': lastTicket.provider.name,
          'address': lastTicket.provider_site.address,
          'cost': cost[0].price_weekday,
          "date": appointment_date.toISOString(),
          'by_connection': this.findByConnectionTicket()
        }
        this.provider_letter = provider_info
      }

      this.showletter3 = true;
      this.showletter2 = false;
      this.showletter = false;
      this.showletter4 = false;
      this.showletter5 = false;

    } else if (op == 4) {
      this.applicant_name.emit(this.assistancecase.applicant_name);

      this.applicant_id.emit(this.assistancecase.member.national_id);
      this.country.emit(this.assistancecase.country.id);
      const realgroup = this.filtergroups(groups);
      let lastTicket: AssistanceTicket;
      lastTicket = realgroup.shift();


      if (lastTicket.provider) {
        let cost = lastTicket.coverage.assistancePrices.filter((e) => e.service_id == lastTicket.service_id)
        if (!this.assistancecase.appointment_date) {
          this.assistancecase.appointment_date = moment().add(this.hourTimeZone * -1, 'hours').format("YYYY-MM-DDTHH:mm:ss");
        }

        let appointment_date = new Date(this.assistancecase.appointment_date + 'Z')
        appointment_date.setHours(appointment_date.getHours() + this.hourTimeZone);

        let provider_info = {
          'name': lastTicket.provider.name,
          'address': lastTicket.provider_site.address,
          'cost': cost[0].price_weekday,
          "date": appointment_date.toISOString(),
          'by_connection': this.findByConnectionTicket()
        }
        this.provider_letter = provider_info
      }

      this.showletter = false;
      this.showletter2 = false;
      this.showletter3 = false;
      this.showletter4 = true;
      this.showletter5 = false;

    } else if (op == 5) {
      this.showletter = false;
      this.showletter2 = false;
      this.showletter3 = false;
      this.showletter4 = false;
      this.showletter5 = true;
    }

    this.patient_data = {
      'patient': this.assistancecase?.member?.name,
      'identification': this.assistancecase?.member?.national_id
    };
  }

  fitMap() {
    setTimeout(() => {
      if (this.mapOverlays.length > 0) {
        this.isEmbeddedMap = false;
        let urlTmp = ""
        let latitudes = [];
        let longitudes = [];

        this.mapOverlays.forEach(marker => {
          let position = marker.getPosition();
          latitudes.push(position.lat());
          longitudes.push(position.lng());
          let color = "red"; // color por defecto
          let label = "M"; // etiqueta por defecto

          if (marker.title === "Ubicacion Cliente") {
            color = "green";
            label = "C";
          } else if (marker.title === "Ubicacion Destino") {
            color = "orange";
            label = "D";
          } else if (marker.title === "Ubicacion Proveedor") {
            color = "purple";
            label = "P";
          }

          urlTmp += `&markers=color:${color}%7Clabel:${label}%7C${position.lat()},${position.lng()}`;
        });

        let minLat = Math.min(...latitudes);
        let maxLat = Math.max(...latitudes);
        let minLng = Math.min(...longitudes);
        let maxLng = Math.max(...longitudes);

        let centerLat = (minLat + maxLat) / 2;
        let centerLng = (minLng + maxLng) / 2;

        // Estos son valores aproximados para el cálculo del zoom, pueden necesitar ajustes
        let zoomLat = Math.round(Math.log(600 * 360 / (maxLat - minLat) / Math.PI) / Math.LN2);
        let zoomLng = Math.round(Math.log(300 * 360 / (maxLng - minLng) / Math.PI) / Math.LN2);
        let zoom = Math.min(zoomLat, zoomLng);

        this.urlStaticMap = `https://maps.googleapis.com/maps/api/staticmap?center=${centerLat},${centerLng}&zoom=${zoom / 2}&size=600x600&maptype=roadmap${urlTmp}&key=${this.API_KEY}`;
      } else {
        this.isEmbeddedMap = true;
      }
    }, 1000);
  }

  onTicketCreate(creatticket: AssistanceTicket) {
    this.onCancelEdit();
    this.messageService.clear();

    creatticket.case_id = Number(this.case_id);
    creatticket.user_id = Number(this.user_id);
    if (creatticket.ticket_type !== this.ticketSvc.PROGRAMMED) {
      creatticket.datetime = null;
    }
    if (
      this.stepperReadOnly == true &&
      creatticket.ticket_type == this.ticketSvc.ASSIGN_PROVIDER
    ) {
      this.isDisabled.emit(false);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `No es posible asignar proveedor en este momento.`,
      });
      return false;
    }

    // Set comment unassigned user
    if (creatticket.ticket_type == 17) {
      creatticket.comment =
        'El usuario ' +
        this.assistancecase.created_by.username +
        ' se desasignó la gestión. ' +
        creatticket.comment;
    }

    this.api.assistancetickets.create(creatticket).promise()
      .then(async tickets => {

        let index = -1;
        let returnBuca = false;
        tickets.map(async (value, index_) => {
          if ('status_buca' in value) {
            if ('return_buca' in value) returnBuca = value['return_buca'];
            this.messageService.add({
              severity: value['status_buca'],
              life: 5000,
              summary: value['summary'],
              detail: value['message']
            });
            index = index_;
          }
          if ('status_sinister' in value) {
            this.messageService.add({
              severity: value['status_sinister'],
              life: 5000,
              summary: value['summary'],
              detail: value['message']
            });
            index = index_;
            if (value['status_sinister'] == "error") {
              await new Promise<void>((resolve) => {
                setTimeout(() => {
                  resolve();
                }, 3000); // 3 seconds
              });
              this.initialize()
            }
            return
          }
        });
        if (returnBuca) return;
        tickets = tickets.filter(ticket => !('status_sinister' in ticket) && !('status_buca' in ticket));

        if (creatticket.buca_action == 2) {
          let data = {}
          data["case_id"] = creatticket.case_id
          data["reason"] = creatticket.comment
          this.api.buca.cancelAppointment(data).promise()
            .then(res => {
              if (res.code == 200) {
                this.ticketMessage({ 'severity': 'info', 'summary': 'Info', 'detail': res.message });
              }
              else {
                this.ticketMessage({ 'severity': 'error', 'summary': 'Error', 'detail': res.message });
              }
            }).catch(
              err => {
                this.ticketMessage({ 'severity': 'error', 'summary': 'Error', 'detail': 'Fallo cancelando la cita en BUCA' });
              })
        }
        if (creatticket?.sinister_action == 2) {
          let data = {}
          data["case_id"] = creatticket.case_id
          data["reason"] = creatticket.comment
          this.api.sds.cancelClaimFromApolo(data, creatticket.case_id).promise()
            .then(res => {
              if (res.code == 200) {
                this.ticketMessage({ 'severity': 'info', 'summary': 'Info', 'detail': res.message });
              }
              else {
                this.ticketMessage({ 'severity': 'error', 'summary': 'Error', 'detail': res.message });
              }
            }).catch(
              err => {
                this.ticketMessage({ 'severity': 'error', 'summary': 'Error', 'detail': 'Fallo cancelando la cita en el Modulo de Siniestros' });
              })
        }

        const orderticket = tickets.reverse();
        this.isDisabled.emit(false);
        this.translate.get('Assistance ticket created')
          .subscribe((res: string) => {
            this.addService_isDisabled = true;
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: `${res}: ${orderticket[0].id}`
            });
          });
        this.assistancetickets = orderticket.concat(this.assistancetickets);
        this.totalCount = this.totalCount + orderticket.length;

        // Set data provider if this ticket set the provider
        if (creatticket.ticket_type == this.ticketSvc.ASSIGN_PROVIDER && creatticket.provider_status == 1) {

          let assignProviderTicketIndex = _.findIndex(this.assistancetickets, { 'ticket_type': 2 });
          if (assignProviderTicketIndex >= 0) {
            this.ticketProviderExists = true;
          }

          let assignProviderIndex = _.findIndex(this.assistancetickets, { 'ticket_type': 2, 'provider_status': 1 });

          const dbRefAssistanceCases = ref(this.db, 'asistance_cases');
          const childAssistanceCases = child(dbRefAssistanceCases, this.case_id.toString());
          onValue(childAssistanceCases, (snap) => {
            let data = snap.val();
            if (this.mapOverlays.length > 1) {
              try {
                if (data.location.latitude == 0 || data.location.longitude == 0) {
                  this.showroute = false;
                } else {
                  this.showroute = true;
                }
              } catch (error) {
                console.log(error);
              }
              this.mapOverlays.forEach((marker, i) => {
                if (marker.title == 'Ubicacion Proveedor' && data.location) {
                  this.mapOverlays[i] = new google.maps.Marker({
                    position: {
                      lat: data.location.latitude,
                      lng: data.location.longitude
                    },
                    title: "Ubicacion Proveedor",
                    icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_client22.png'
                  });
                  this.fitMap();
                } else {
                  this.mapOverlays.push(new google.maps.Marker({
                    position: {
                      lat: data.location.latitude,
                      lng: data.location.longitude
                    },
                    title: "Ubicacion Proveedor",
                    icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_client22.png'
                  }));
                  this.fitMap();
                }
              });

            } else {
              if (assignProviderIndex >= 0 && this.assistancetickets[assignProviderIndex].latitude && this.assistancetickets[assignProviderIndex].longitude) {
                try {
                  if (this.assistancetickets[assignProviderIndex].latitude == 0 || this.assistancetickets[assignProviderIndex].longitude == 0) {
                    this.showroute = false;
                  } else {
                    this.showroute = true;
                  }
                } catch (error) {
                  console.log(error);
                }
                this.mapOverlays.push(new google.maps.Marker({
                  position: {
                    lat: this.assistancetickets[assignProviderIndex].latitude,
                    lng: this.assistancetickets[assignProviderIndex].longitude,
                  },
                  title: "Ubicacion Proveedor",
                  icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_client22.png'
                }));
              }
            }

          });

          if (assignProviderIndex >= 0) {
            this.provider = this.assistancetickets[assignProviderIndex].provider;
            this.provider_site_data = this.assistancetickets[assignProviderIndex].provider_site;
            this.provider_id = this.assistancetickets[assignProviderIndex].provider_id;
            this.provider_site_id = this.assistancetickets[assignProviderIndex].provider_site_id;
            this.coverage_id = this.assistancetickets[assignProviderIndex].coverage_id;
          }

          this.fitMap();
        }

        this.setFlagsByTicket();

        this.autoStepshow(orderticket[0], false);

        // If ticket type is cancellation
        // call to autoclose
        if (this.close_ticket_on_cancel) {
          if (creatticket.ticket_type == this.ticketSvc.CANCELED_BY_SUPERVISOR ||
            creatticket.ticket_type == this.ticketSvc.CANCELED_BY_CLIENT ||
            creatticket.ticket_type == this.ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT ||
            creatticket.ticket_type == this.ticketSvc.CANCELED_BY_PROVIDER ||
            creatticket.ticket_type == this.ticketSvc.CANCELED_BY_CLIENT_WITHOUT_COST) {
            this.autocloseCase(creatticket);
          }
        }

        this.api.assistanceClaimNumber.get(this.case_id).promise()
          .then(sds_claim => {
            this.assistancecase.sds_sinister_claim = sds_claim
          })
          .catch(e => {
            const errmsg = JSON.parse(e['_body']);
            this.isDisabled.emit(false);
            this.translate.get('Error creating new assistance tiket')
              .subscribe((res: string) => {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: `${res}: ${e.statusText} ${errmsg['error']}`
                });
              });
          });

      })
      .catch(e => {
        if (e['_body']) {
          const errmsg = JSON.parse(e['_body']);
          this.isDisabled.emit(false);
          this.translate.get('Error creating new assistance tiket')
            .subscribe((res: string) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: `${res}: ${e.statusText} ${errmsg['error']}`
              });
            });
        } else {
          let error_msg = '';
          this.isDisabled.emit(false);
          try {
            error_msg = e.error.error;
            this.translate
              .get(error_msg)
              .subscribe((res: string) => {
                error_msg = res;
              });
          } catch {
            error_msg = e.error;
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${error_msg}`
          })
        }
      });
    // }
    this.commentServiceConfig = '';
    return true;
  }

  ticketMessage(message) {
    this.messageService.add({
      severity: message.severity,
      summary: message.summary,
      detail: message.detail
    });
  }

  onTicketUpdate(data) {
    const updateticket = data.pp1;
    if (data.pp2 && !this.editbtnshow[updateticket.service_id]) {
      // if ticket update time more than 5 min
      return;
    }
    this.onCancelEdit();
    this.messageService.clear();
    let edited = null;
    edited = _.find(this.assistancetickets, (p) => p.id === updateticket.id);
    if (edited === null) {
      this.onTicketCreate(updateticket);
      return;
    }
    Object.assign(edited, updateticket);
    this.api.assistancetickets
      .update(updateticket, updateticket.id)
      .promise()
      .then((ticket) => {
        this.isDisabled.emit(false);
        this.translate
          .get('Assistance ticket updated')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'info',
              summary: 'Info',
              detail: `${res}: ${ticket.id}`,
            });
          });
      })
      .catch((e) => {
        this.isDisabled.emit(false);
        this.translate
          .get('Error updating assistance ticket')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.error}`,
            });
          });
      });
  }

  ticketCancel(groups: any) {

    // Get ticket provider arrived, to dead services only
    let ticket_provider_arrived = this.gettickettypefromGroup(groups, this.ticketSvc.PROVIDER_ARRIVED)

    // Verify if not exists cancellation tickets, else autoclose case
    let ticket_cancellation_1 = this.gettickettypefromGroup(groups, this.ticketSvc.CANCELED_BY_SUPERVISOR);
    let ticket_cancellation_2 = this.gettickettypefromGroup(groups, this.ticketSvc.CANCELED_BY_CLIENT);
    let ticket_cancellation_5 = this.gettickettypefromGroup(groups, this.ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT);
    let ticket_cancellation_3 = this.gettickettypefromGroup(groups, this.ticketSvc.CANCELED_BY_PROVIDER);
    let ticket_cancellation_4 = this.gettickettypefromGroup(groups, this.ticketSvc.CANCELED_BY_CLIENT_WITHOUT_COST);

    if (ticket_cancellation_1 || ticket_cancellation_2 || ticket_cancellation_3 || ticket_cancellation_4 || ticket_cancellation_5) {

      let ticket = this.gettickettypefromGroup(groups, this.ticketSvc.ASSIGN_SERVICE);
      const question = 'Would you like to close the service';
      const dTitle = 'Close';
      this.translate.get([question, dTitle]).subscribe((res: string) => {
        this.confirmation.confirm({
          message: `${res[question]} "${ticket.service.name}"?`,
          header: `${res[dTitle]} "${ticket.service.name}"`,
          icon: 'fa fa-question-circle',
          accept: () => {
            this.autocloseCase(ticket);
          },
        });
      });

      return;
    }

    const realgroup = this.filtergroups(groups);
    let lastTicket: AssistanceTicket;
    lastTicket = realgroup.shift();
    this.groupservicename = lastTicket.service.name;
    this.cancelDialog = true;
    this.cancelTicket.emit({ Ticket: lastTicket, ticket_provider_arrived });
  }

  setServiceconfig(groups: any) {
    this.ServiceConfigComponent.initialize();
    this.serviceConfiguration = true;
    let lastTicket: AssistanceTicket;
    lastTicket = groups[0];
    this.serviceConfigTicket.emit({ ticket: lastTicket });
  }

  setException(groups: any) {
    this.loadExceptionType();
    this.groupServiceConfig = groups;
    // let lastTicket: AssistanceTicket;
    // lastTicket = Object.assign({}, groups[0]);
    // delete lastTicket.id;
    // this.exceptionTicket.emit({ticket: lastTicket});
    this.showDialogGeneral = false;
    this.showProgramedService = false;
    this.showBillFormDialog = false;
    this.showExceptionDialog = true;
  }

  openExceptionDialog(pTicket: AssistanceTicket) {
    this.showExceptionDialog = true;
    this.exceptionTicket.emit({ ticket: pTicket });
  }

  onSetService(ticket) {
    this.onTicketCreate(ticket);
  }



  onChangeItemSelected(itemSelected) {
    this.itemSelected = itemSelected;
    let value = itemSelected.id;
    //this.program_type = +value || null;
    //this.editticket.program_type = +value || null;
    this.onSelectProgramSubType(value)
  }

  onSetServiceProgramed() {
    if (
      this.commentServiceConfig &&
      this.programTimeService &&
      this.itemSelected
    ) {
      let lastTicket: AssistanceTicket;
      lastTicket = _.cloneDeep(this.groupServiceConfig[0]);
      lastTicket.ticket_type = 11;
      lastTicket.program_subtype = this.program_subtype
      lastTicket.comment = this.commentServiceConfig;
      lastTicket.datetime = this.programTimeService;
      lastTicket.program_type = this.itemSelected.id;
      this.onTicketCreate(lastTicket);
      this.showConfirmByConection = false;
      this.showConfirmByRecordination = false;
      this.showConfirmByReimburse = false;
      this.showProgramedService = false;
      this.showDialogGeneral = true;
      this.showExceptionDialog = false;
      this.showBillFormDialog = false;
    }
  }

  onSetServiceByConection() {
    if (this.commentServiceConfig) {
      let lastTicket: AssistanceTicket;
      lastTicket = _.cloneDeep(this.groupServiceConfig[0]);
      lastTicket.ticket_type = 12;
      lastTicket.comment = this.commentServiceConfig;
      this.onTicketCreate(lastTicket);
      this.showConfirmByConection = false;
      this.showConfirmByRecordination = false;
      this.showConfirmByReimburse = false;
      this.showProgramedService = false;
      this.showDialogGeneral = true;
      this.showExceptionDialog = false;
      this.showBillFormDialog = false;
    }
  }

  onSetServiceByRecordination() {
    if (this.commentServiceConfig) {
      let lastTicket: AssistanceTicket;
      lastTicket = _.cloneDeep(this.groupServiceConfig[0]);
      lastTicket.ticket_type = 30;
      lastTicket.comment = this.commentServiceConfig;
      this.onTicketCreate(lastTicket);
      this.showConfirmByConection = false;
      this.showConfirmByRecordination = false;
      this.showConfirmByReimburse = false;
      this.showProgramedService = false;
      this.showDialogGeneral = true;
      this.showExceptionDialog = false;
      this.showBillFormDialog = false;
    }
  }

  onSetServiceReimburse() {
    if (this.commentServiceConfig) {
      let lastTicket: AssistanceTicket;
      lastTicket = _.cloneDeep(this.groupServiceConfig[0]);
      lastTicket.ticket_type = 15;
      lastTicket.comment = this.commentServiceConfig;
      this.onTicketCreate(lastTicket);
      this.showConfirmByReimburse = false;
      this.showConfirmByConection = false;
      this.showConfirmByRecordination = false;
      this.showProgramedService = false;
      this.showDialogGeneral = true;
      this.showExceptionDialog = false;
      this.showBillFormDialog = false;
    }
  }

  onSetException() {
    if (
      this.commentServiceConfig &&
      this.supervisorSelectedException &&
      this.itemSelected
    ) {
      let lastTicket: AssistanceTicket;
      lastTicket = _.cloneDeep(this.groupServiceConfig[0]);
      lastTicket.ticket_type = 14;
      lastTicket.comment = this.commentServiceConfig;
      lastTicket.supervisor_id = this.supervisorSelectedException;
      lastTicket.exception_type = this.itemSelected.id;
      this.onTicketCreate(lastTicket);
      this.showExceptionDialog = false;
      this.showConfirmByReimburse = false;
      this.showConfirmByConection = false;
      this.showConfirmByRecordination = false;
      this.showProgramedService = false;
      this.showDialogGeneral = true;
      this.showBillFormDialog = false;
    }
  }

  cancelReprocess() {
    this.isReprocessDialogVisible = false;
  }

  saveReprocess(reprocess: AssistanceReprocess) {
    this.isReprocessDialogVisible = false;
  }

  savedReprocess(reprocess: AssistanceReprocess) {
    if (reprocess === null) {
      // Reprocess not saved, show error
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Error creando reproceso',
      });
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'Reproceso creado',
      });
    }
  }

  updatedDate($event) {
    this.modifyDate = false;
    if ($event == true) {
      this.messageService.add({
        severity: 'info',
        summary: 'Info',
        detail: 'cambio exitoso',
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'cambio erroneo',
      });
    }
    this.getAssistanceTicket();
  }

  showReprocessForm() {
    this.isReprocessDialogVisible = true;
  }


  isAllowedToCreateReprocess() {
    let isReprocessNotEvaluated = false;
    if (this.assistancecase) {
      if (!this.assistancecase.is_assistance_reprocess_evaluated) {
        isReprocessNotEvaluated = true;
      }
    }

    return (
      this.iAm([
        'assistance_admin',
        'supervisor',
        'networkleader',
        'quality',
      ]) && isReprocessNotEvaluated
    );
  }

  finishReprocesses() {
    this.api.assistanceCasesById
      .updateReprocessEvaluated(this.case_id)
      .promise()
      .then((assistanceCase) => {
        Object.assign(this.assistancecase, assistanceCase);
        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Reprocesos terminados',
        });
      })
      .catch((e) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error terminando reprocesos',
        });
      });
  }

  addSaveButtonToMap() {
    this.pendingAddMapButton = false;

    // For search address case
    const saveLocationBtn = document.createElement('button');
    saveLocationBtn.setAttribute('class', 'btn btn-primary btn-sm');
    saveLocationBtn.textContent = 'Save';
    // Translate Save location button text
    this.translate.get(saveLocationBtn.textContent).subscribe((res: string) => {
      saveLocationBtn.textContent = res;
    });
    saveLocationBtn.classList.add('updatelocation');
    saveLocationBtn.addEventListener('click', () => {
      this.updateLocation();
    });

    if (this.locationComponent?.map) {
      this.locationComponent.map
        .controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(saveLocationBtn);
    }
    this.showMap.emit(true);
  }

  onMapReady(event) {
    this.customerMap = event.map;
    if (this.caseLocation) {
      this.customerMap.setCenter({
        lat: this.caseLocation.latitude,
        lng: this.caseLocation.longitude,
      });
    }
    if (this.pendingAddMapButton) {
      // this.addSaveButtonToMap();
    }

    this.fitMap();
  }

  onStepsActiveIndexReady(activeIndex, serviceId) {
    // Evaluate active index to set create ticket button visibility
    if (this.listenActiveIndexes[serviceId]) {
      const nextTicketType = this.translateActiveIndexToTicketType(activeIndex);

      this.nextTicketTypes[serviceId] = nextTicketType;

      // Evaluate if the create button should be displayed again
      if (
        this.iAm(['assistance_dispatcher']) ||
        this.iAm(['assistance_dispatcher_vial']) ||
        this.iAm(['assistance_dispatcher_medical'])
      ) {
        // If the service is on an allowed type
        if (
          this.ticketSvc.dispatcherAllowedTypes.indexOf(nextTicketType) !== -1
        ) {
          this.ticketbtnshow[serviceId] = true;
        }
      }
    }

    // Check if need to check step or not
    if (this.checkStepPending[serviceId]) {
      this.checkStepPending[serviceId] = false;
      let ticket: AssistanceTicket;
      const group = _.cloneDeep(this.servicegrouptickets[serviceId]);

      const arrayLength = group.length;
      let realLastTicket = null;
      if (arrayLength > 0) {
        realLastTicket = group[0];
      }
      if (
        (realLastTicket &&
          (realLastTicket.ticket_type == this.ticketSvc.COMMENT ||
            realLastTicket.ticket_type == this.ticketSvc.EXCEPTION ||
            realLastTicket.ticket_type == this.ticketSvc.ASSIGN_SERVICE ||
            realLastTicket.ticket_type ==
            this.ticketSvc.NOTIFY_SELECTED_PROVIDER ||
            realLastTicket.ticket_type == this.ticketSvc.PROVIDER_ARRIVED)) ||
        (realLastTicket.ticket_type == this.ticketSvc.PROGRAMMED &&
          this.validatestep(group))
      ) {
        this.showstep[serviceId] = false;
      } else {
        // Check the step
        // ticket = this.getLastTicketFromGroup(group);
        // this.checkstep(ticket);
      }
    }
  }
  validatestep(group) {
    for (var i = 0; i < group.length; i++) {
      if (group[i].ticket_type >= 3 && group[i].ticket_type <= 5) {

        return true;
      }
    }
    return false;
  }
  gotUserProvider(isDone) {
    this.loaderService.display(false);
    location.reload();
  }

  translateActiveIndexToTicketType(activeIndex) {
    if (activeIndex === 0) {
      return this.ticketSvc.ASSIGN_SERVICE;
    } else if (activeIndex === 1) {
      return this.ticketSvc.ASSIGN_PROVIDER;
    } else if (activeIndex === 2) {
      return this.ticketSvc.NOTIFY_SELECTED_PROVIDER;
    } else if (activeIndex === 3) {
      return this.ticketSvc.PROVIDER_ARRIVED;
    }

    return -1;
  }

  showCloseServiceConfirmation(ticket) {
    if (this.additionalplanservice && this.additionalplanservice.buca_apply == 1 && this.assistancecase?.assistance_sale?.category == 'BUCA INSURANCE') {
      this.ticketMessage({ 'severity': 'error', 'summary': 'Error', 'detail': 'El cierre del servicio se hará desde el portal BUCA por ser un caso de BUCA.' })
      return;
    }
    // Validar que si existe un ticket type 35 y no existe el 36, es por que aun falta la autorizacion con SWAL
    if (this.assistancetickets.find(t => t.ticket_type == 35) && !this.assistancetickets.find(t => t.ticket_type == 36)) {
      Swal.fire({
        title: 'Error',
        text: 'El servicio no puede ser cerrado, aun falta la autorización de la excepción.',
        icon: 'error'
      });
      return;
    }
    // Need to evaluate if user can close the service
    if (
      this.iAm([
        'assistance_admin',
        'supervisor',
        'operator',
        'cabin_agent',
        'networkleader',
        'assistance_dispatcher',
        'assistance_dispatcher_vial',
        'assistance_dispatcher_medical',
      ])
    ) {
      const question = 'Would you like to close the service';
      const dTitle = 'Close';
      this.translate.get([question, dTitle]).subscribe((res: string) => {
        this.confirmation.confirm({
          message: `${res[question]} "${ticket.service.name}"?`,
          header: `${res[dTitle]} "${ticket.service.name}"`,
          icon: 'fa fa-question-circle',
          accept: () => {
            //verficamos si hay que enviar correo
            if (this.assistancecase.apply_survey) {
              //alert('voy a enviar encuesta');
              //this.sendNPSbyEmail(ticket);
            }
            //--si aplican las alertas envio el correo
            if (this.assistancecase.apply_alerts) {
              this.sendAlertEmail();
            }
            //---para lo de enviar alerta deberia enviar en el payload el assitancecase
            this.billDialogBeforeClose(ticket);
          },
        });
      });
    }
  }

  setShowStepTrue(serviceId) {
    if (
      this.iAm([
        'assistance_admin',
        'supervisor',
        'operator',
        'cabin_agent',
        'networkleader',
        'assistance_dispatcher',
        'assistance_dispatcher_vial',
        'assistance_dispatcher_medical',
      ])
    ) {
      // This roles can set it as true

      const grouptickets = this.servicegrouptickets[serviceId];
      if (this.alreadyHasProvider(grouptickets)) {
        this.showstep[serviceId] = true;
        this.flagAssignProvider = false;
      } else {
        // If this case not has provider
        // show form to assign provider
        this.showstep[serviceId] = true;
        this.flagAssignProvider = true;
      }
    }
    // else if (this.iAm(['assistance_dispatcher']) && this.ticketbtnshow[serviceId]) {
    //   // For the dispatcher, only show the step if the create
    //   // Ticket button is visible
    //   this.showstep[serviceId] = true;
    // }
    else {
      this.showstep[serviceId] = false;
    }
  }

  canCloseTicket(ticket) {
    if (
      this.iAm([
        'assistance_admin',
        'supervisor',
        'operator',
        'cabin_agent',
        'networkleader',
        'assistance_dispatcher',
        'assistance_dispatcher_vial',
        'assistance_dispatcher_medical',
      ])
    ) {
      this.showCloseServiceConfirmation(ticket);
    }
    else {
      this.translate.get("Forbidden, please communicate to supervisor").subscribe((msg: string) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: msg,
        });
      });
    }
  }

  canCreateBill() {
    if (
      this.iAm([
        'assistance_admin',
        'supervisor',
        'operator',
        'cabin_agent',
        'networkleader',
        'assistance_dispatcher',
        'assistance_dispatcher_vial',
        'assistance_dispatcher_medical',
      ])
    ) {
      return true;
    }

    return false;
  }

  getLastTicketFromGroup(group) {
    this.view_letter()
    const realgroup = this.filtergroups(group);
    let lastTicket: AssistanceTicket;
    lastTicket = realgroup.shift();

    return lastTicket;
  }
  gettickettypefromGroup(group, ticket_type) {
    let copyGroup = _.cloneDeep(group);
    copyGroup = _.filter(copyGroup, (a: any) => a.ticket_type == ticket_type);
    let lastTicket: AssistanceTicket;

    lastTicket = copyGroup.shift();

    return lastTicket;
  }
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
  editmanualcase() {
    this.showDialogGeneral = false;
    this.showeditManual = true;
  }
  showPreviewAttachment(attachment) {


    this.setAttachment.emit(attachment);
    this.showPreviewDialog = true;
  }
  closePreviewAttachment() {
    this.showPreviewDialog = false;
  }
  /* getProviderAppLocation(){
    if (this.assistancecase.appCase.length != 0) {
      this.api.assistanceApp.getProviderLocation()
      .params({provider_id:this.assistancecase.appCase[0]["provider_user_id"]}).promise()
      .then(providerlocation => {
        this.providerAppLocation.latitude = providerlocation.latitude
        this.providerAppLocation.longitude = providerlocation.longitude
      })
      this.providerLocationRT.emit(this.providerAppLocation)
    }
  } */

  /**
   * Method to unassign self case
   * @param groups
   */
  dispatcherUnassignCase(groups: any) {
    let lastTicket: AssistanceTicket;
    lastTicket = _.cloneDeep(groups[0]);

    // Set ticket type to 18 (assign / unassign dispatcher)
    lastTicket.ticket_type = 17;

    this.editcommentflag = false;
    this.commentTicket.emit({ Ticket: lastTicket, Case: false });
    this.showCommentUserDialog = true;
  }

  onSelectCourtesy(value) {
    this.courtesy_ = value;

  }
  isCourtesy() {

  }

  onCancel() {
    this.cancelEvent.emit();
  }

  viewsurveyoptions() {
    this.survey_options = true;

    this.view_whatsapp();
  }

  alreadyHasProviderArrived(group: any) {
    const copyGroup = _.cloneDeep(group);

    const lastTicket = this.getLastTicketFromGroup(copyGroup);

    if (lastTicket.provider_id) {
      return true;
    } else {
      return false;
    }
  }

  send_sms_survey() {

    const filter = { case_id: this.case_id };
    this.api.assistancecases
      .sms_survey()
      .filter(filter)
      .promise()
      .then((data) => {
        this.translate.get('Send Survey').subscribe((res: string) => {
          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: 'Encuesta enviada por SMS',
          });
        });
      });
    this.survey_options = false;
  }

  send_email_survey() {


    const filter = {
      case_id: this.case_id,
      service_id: this.assistancetickets[0].service.id,
    };
    this.api.assistancecases
      .email_survey()
      .filter(filter)
      .promise()
      .then((data) => {
        this.translate.get('Send Survey').subscribe((res: string) => {
          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: 'Encuesta enviada por email',
          });
        });
      });
    this.survey_options = false;
  }

  send_whatsapp_survey() {

    const filter = { case_id: this.case_id };
    this.api.assistancecases
      .whatsapp_survey()
      .filter(filter)
      .promise()
      .then((data) => {
        this.translate.get('Send Survey').subscribe((res: string) => {
          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: 'Encuesta enviada por whatsapp',
          });
        });
      });
    this.survey_options = false;
  }

  async view_whatsapp() {

    const filter = { case_id: this.case_id };
    await this.api.assistancecases
      .view_whatsapp()
      .filter(filter)
      .promise()
      .then((data) => {
        this.whatsapp = data;
      });
  }

  getlink() {
    // 
    // 
    // const filter = {'plan_id': this.plan_id};
    //  this.api.assistanceplans.get_icon().filter(filter).promise()
    //     .then(data => {
    //       
    //       
    //       this.url_collaborate = data.url_collaborator
    //     });
  }

  async showAditionalInformation() {
    this.showaditionalinformation = true;




    this.additionalplanservice = new AssistancePlanService();
    const filter = {
      plan_id: this.plan_id,
      service_id: this.assistancetickets[0].service.id,
    };
    await this.api.assistanceplanservices
      .get_extrainfo()
      .filter(filter)
      .promise()
      .then((data) => {
        this.additionalplanservice.emergency_reporting_time =
          data[0].emergency_reporting_time;
        this.additionalplanservice.territoriality = data[0].territoriality;
        this.additionalplanservice.special_condition =
          data[0].special_condition;
        this.additionalplanservice.max_amount = data[0].max_amount;
        this.additionalplanservice.max_amount_general =
          data[0].max_amount_general;
        this.additionalplanservice.sinister_apply = data[0].sinister_apply;
        this.additionalplanservice.buca_apply = data[0].buca_apply
      });

    try {
      const filter2 = {
        plan_id: this.plan_id,
        service_id: this.assistancetickets[0].service.id,
        total: this.additionalplanservice.max_amount_general,
      };

      await this.api.assistanceplanservices
        .get_operations12()
        .filter(filter2)
        .promise()
        .then((data) => {
          //this.excedente2 = this.bill.price_billed - data[0]['disponible']
          this.consumido = data[0]['consumido'];
          this.disponible = data[0]['disponible'];
        });
    } catch (exception) {


    }
  }

  onNotificationReceived(payload) {
    if (
      payload.case_id &&
      payload.case_id.indexOf(this.route.snapshot.params['id'].toString()) >= 0
    ) {

      this.initialize();
    }
  }

  printStateDistrict() {


  }

  showMoreInformation() {
    this.expand_more = !this.expand_more;
  }
  /*viewaudios() {
    this.showAudiosDialog = true;
    this.showProgramedService = false;
    this.showExceptionDialog = false;
    this.showBillFormDialog = false;
    this.showDialogGeneral = false;
    this.api.CaseAudios.getAudios(this.case_id)
      .promise()
      .then((res) => {
        this.audioList = res;
        
        for (let audio of this.audioList) {
          let tmpData = {
            showAudio: false,
            audioURL: `/api/get/assistanceAudio/${audio.interaction_id}`,
            startTime: audio.fecha, //.split('T')[0],
            created_time: audio.created_time,
            callerLastName: audio.usuario,
            pkId: audio.interaction_id,
            agentDispositionName: audio.usuario,
            showButton: true,
            updated_time: audio.updated_time.split('T')[1],
          };
          this.caseAudios.push(tmpData);
        }
      });
  }
  */

  viewaudios() {
    this.showAudiosDialog = true;
    this.showProgramedService = false;
    this.showExceptionDialog = false;
    this.showBillFormDialog = false;
    this.showDialogGeneral = false;
    this.getAudioCasesv2()
  }


  viewRisks(groups: any) {
    this.showRisks = true;
    this.groupsRisk = groups;
  }


  viewComplaints(groups: any) {
    this.showComplaints = true;
    this.groupsComplaint = groups;
  }


  onSetRisk() {

    let lastTicket: AssistanceTicket;
    lastTicket = _.cloneDeep(this.groupsRisk[0]);

    // Set ticket type to comment 9
    lastTicket.ticket_type = 9;
    lastTicket.comment = null;

    if (this.assistancecase.service_rating) {
      lastTicket.comment = 'Evento riesgoso: ';
      lastTicket.comment += this.risks.find(
        (element) => element.value_ == this.assistancecase.service_rating
      ).description;
    }

    lastTicket.case_id = Number(this.case_id);
    lastTicket.user_id = Number(this.user_id);
    lastTicket.datetime = null;

    let payload = {
      case_id: this.assistancecase.id,
      service_rating: this.assistancecase.service_rating,
      ticket_comment: lastTicket,
    };

    this.LoaderService.display(true);

    this.api.risks
      .post(payload)
      .promise()
      .then((tickets) => {
        this.LoaderService.display(false);
        this.showRisks = false;
        this.translate.get('Saved risk').subscribe((res: string) => {
          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: res,
          });
        });

        const orderticket = tickets.reverse();
        this.assistancetickets = orderticket.concat(this.assistancetickets);
        this.totalCount = this.totalCount + orderticket.length;
        // mensaje para buca cuando está creado el procedimiento


        this.autoStepshow(orderticket[0], false);
      })
      .catch((e) => {
        this.LoaderService.display(false);
        this.showRisks = false;
        this.translate
          .get('An error occurred while trying to save the risk')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: res,
            });
          });
      });

  }

  saveComplaint() {


    let lastTicket: AssistanceTicket;
    lastTicket = _.cloneDeep(this.groupsComplaint[0]);

    // Set ticket type to comment 9
    lastTicket.ticket_type = 9;
    lastTicket.comment = null;

    if (this.assistancecase.complaint) {
      lastTicket.comment = 'Queja: ';
      lastTicket.comment += this.complaints.find(
        (element) => element.value_ == this.assistancecase.complaint
      ).description;
    }

    lastTicket.case_id = Number(this.case_id);
    lastTicket.user_id = Number(this.user_id);
    lastTicket.datetime = null;

    let payload = {
      case_id: this.assistancecase.id,
      complaint: this.assistancecase.complaint,
      ticket_comment: lastTicket,
    };


    this.LoaderService.display(true);

    this.api.complaints
      .post(payload)
      .promise()
      .then((tickets) => {
        this.LoaderService.display(false);
        this.showComplaints = false;
        this.translate.get('Saved complaint').subscribe((res: string) => {
          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: res,
          });
        });

        const orderticket = tickets.reverse();
        this.assistancetickets = orderticket.concat(this.assistancetickets);
        this.totalCount = this.totalCount + orderticket.length;
        this.autoStepshow(orderticket[0], false);
      })
      .catch((e) => {
        this.LoaderService.display(false);
        this.showComplaints = false;
        this.translate
          .get('An error occurred while trying to save the complaint')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: res,
            });
          });
      });

  }

  setProgramedTicket(group: any) {
    this.showProgramedService = true;
    this.showExceptionDialog = false;
    this.showBillFormDialog = false;
    this.showDialogGeneral = false;
    this.showAudiosDialog = false;
    this.groupServiceConfig = group;
    this.api.assistance_programming_types
      .get()
      .promise()
      .then(
        (resp) => {

          this.assistance_programming_types = resp;
          this.LoaderService.display(false);
        },
        (e) => {

        }
      );
  }

  setReimburse(group: any) {
    this.groupServiceConfig = group;
    this.showConfirmByReimburse = true;
  }

  setByConectionTicket(group: any) {
    this.groupServiceConfig = group;
    this.showConfirmByConection = true;
  }

  setByRecordinationTicket(group: any) {
    this.groupServiceConfig = group;
    this.showConfirmByRecordination = true;
  }

  loadExceptionType() {
    this.catalogCache.getExceptionTypes()
      .toPromise()
      .then((types) => {
        this.exceptionsType = types;
      })
      .catch((error) => {
        console.error('Error loading exception types:', error);
        this.exceptionsType = [];
      });
  }

  async CommentOn() {
    const f = new Date();
    var hora = f.getHours() + ':' + f.getMinutes() + ':' + f.getSeconds();
    let user;
    let filter: any = {
      text: null,
      member_id: null,
    };
    await this.api.me
      .get()
      .promise()
      .then((data) => {
        user = data;
        this.me.updateToken(user);
      })
      .catch((e) => {

      });

    this.text_general =
      this.text_general +
      '\n' +
      f.getDate() +
      '/' +
      (f.getMonth() + 1) +
      '/' +
      f.getFullYear() +
      ' - ' +
      hora +
      '\n' +
      user.name +
      ': ' +
      this.commentServiceConfig +
      '\n';
    filter.text = this.text_general;
    filter.member_id = this.assistancecase.member.id;
    this.api.assistancecases
      .setComment()
      .filter(filter)
      .promise()
      .then((res) => {

      })
      .catch((error) => {

      });

    this.commentServiceConfig = '';
  }

  notifyAssignProviderView() {
    this.flagAssignProvider = !this.flagAssignProvider;
  }

  onSelectService(service_id) {
    if (service_id) {
      this.api.assistanceplanAmount
        .getByPlan(
          service_id,
          this.plan_id,
          this.assistancecase.assistance_sale_id,
          this.assistancecase.member_id
        )
        .promise()
        .then((data) => {
          // this.areAmountsVisible = true;
          this.remaining_assistances = data.remaining_assistances;
          this.used_services = data.used_services;
          // this.total_cases = data.total_cases;
          this.courtesy_assistances = data.courtesy_assistances;
          // this.is_on_waiting_period = data.on_waiting_period;

          // if (
          //   this.remaining_assistances !== undefined &&
          //   this.remaining_assistances <= 0
          // ) {
          //   // Only offer by connection
          //   this.maxAssistancesReached = true;
          //   this.onSelectConnection(1);
          // } else if (this.is_on_waiting_period) {
          //   this.onSelectConnection(1);
          // }
        })
        .catch((e) => { });
    }
  }

  updateTicket(assistanceTicket: AssistanceTicket) {
    this.showCaseFormDialog = false;
    this.getAssistanceTicket();
  }

  copyToClipBoard(pkid: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = pkid;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'ID Copiado',
    });
  }
  getColorValue(id) {


    return 'yellow';
  }

  view_letter() {



    this.api.assistanceplanservices.get_participationamount(this.plan_id, this.assistancetickets[0].service.id).promise()
      .then(participation => {
        if (Array.isArray(participation.data) && participation.data.length > 0) {

          this.pago_copago = participation.data[0].participation_amount
          if (participation.data[0].participation_amount > 0) {
            this.copago = true

          }

          this.plan_max_amount_events = participation.data[0].max_amount;

        }


      });
  }

  update_triage() {
    const filter = { 'case_id': this.case_id, 'triage': this.stopLightNumber };
    try {
      this.api.assistancecases.update_triage().filter(filter).promise()
        .then(data => {
          this.translate.get('Triage')
            .subscribe((res: string) => {
              this.messageService.add({
                severity: 'info',
                summary: 'Info',
                detail: "Triage Actualizado"
              });
              this.getAssistanceTicket();
            });



        });
    } catch (exception) {




    }


    this.triage_window = false;
    this.stopLightNumber = 0;




  }


  onCancelT() {
    this.triage_window = false;
    this.stopLightNumber = 0;
  }
  setRed() {
    this.stopLightNumber = 1;
    //this.editticket.triage = 1;
  }
  setYellow() {
    this.stopLightNumber = 2;
    //this.editticket.triage = 2;
  }
  setGreen() {
    this.stopLightNumber = 3;
    //this.editticket.triage = 3; 
  }
  getclass1(n) {

    if (n == this.stopLightNumber) {

      return 'redbuttonselect'

    } else {
      return "redbutton"
    }
  }


  getclass2(n) {

    if (n == this.stopLightNumber) {

      return 'yellowbuttonselect'

    } else {
      return "yellowbutton"
    }
  }


  getclass3(n) {

    if (n == this.stopLightNumber) {

      return 'greenbuttonselect'

    } else {
      return "greenbutton"
    }
  }
  async ReassignTriage(servi: any) {

    let providers_rea
    this.country.emit(this.assistancecase.country.id)
    //this.service.emit(servi)



    const filter = {
      country_id: this.assistancecase.country.id,
      service_id: servi,
      status: 1
    };
    this.triage_window = true







  }




  async showReasignProviderCard(servi: any) {

    let providers_rea = null
    this.service2.emit(servi)

    const filter = {

      service_id: servi,
      status: 1
    };

    this.showProviderView = false;
    this.showReasignProviderView = true;
    this.showDialogGeneral = false;
    this.flagAssignProvider = true;
    //this.getProviderInfo();

  }


  hideReasignProvidercard(e) {
    this.showProviderView = false;
    this.showReasignProviderView = false;
    this.showDialogGeneral = true;
    this.flagAssignProvider = false;
  }



  onSelectProgramSubType_(event, code) {


    let value2 = event.target.value;




    this.program_subtype = +code || null;




  }

  onSelectProgramSubType(val) {
    this.loaderService.display(true);



    this.api.assistance_programming_types
      .getsubtypes(val)
      .promise()
      .then(resp => {

        this.assistance_programming_subtypes = resp;
        this.loaderService.display(false);


      }, e => {

        this.loaderService.display(false);

      })
  }

  //para edit
  initfield() {
    // init product, plan, sale
    this.assistancesales = [];
    this.assistanceplans = [];
    this.assistanceProducts = [];
    this.shortProducts = [];
    this.assistancecase.assistance_id = null;
    this.assistancecase.assistance_plan_id = null;
    this.assistancecase.assistance_sale_id = null;
    this.selectedSale = null;
  }

  onSelectCountry(country_id) {

    if (country_id == 1) {
      this.PLAN_BY_CONECTION_ID = 914
    } else if (country_id == 2) {
      this.PLAN_BY_CONECTION_ID = 915
    } else if (country_id == 3) {
      this.PLAN_BY_CONECTION_ID = 916
    } else if (country_id == 4) {
      this.PLAN_BY_CONECTION_ID = 917
    } else if (country_id == 5) {
      this.PLAN_BY_CONECTION_ID = 918
    } else if (country_id == 7) {
      this.PLAN_BY_CONECTION_ID = 919
    } else if (country_id == 8) {
      this.PLAN_BY_CONECTION_ID = 920
    } else if (country_id == 9) {
      this.PLAN_BY_CONECTION_ID = 921
    } else if (country_id == 10) {
      this.PLAN_BY_CONECTION_ID = 922
    } else if (country_id == 11) {
      this.PLAN_BY_CONECTION_ID = 923
    }



    this.initfield();
    if (country_id == null) {
      this.countryy = new Country();
      //this.states = null;
      this.assistancecase.country_id = null;
      this.assistanceProducts = null;
      this.assistancecase.assistance_id = null;
      this.sale_status = null;
      //this.statesDistrict = [];
      this.assistancecase.state_district_id = null;
      //this.state_text = '';
      //this.state_district_text = '';
      //this.showStateText = false;
      this.country_id = null;
    } else {
      this.countryy = _.find(this.countries, function (c) {
        return c.id === country_id;
      });

      this.assistancecase.country_id = country_id;

      this.api.states
        .get(this.countryy.id)
        .promise()
        .then((states) => {
          //this.states = states;
        });
      if (this.countryy.locale.length > 2) {
        this.countryy.locale = this.countryy.locale.split('-')[1].toLowerCase();
      }

      this.country_code.country_name = this.countryy.name;
      this.country_code.country_local = this.countryy.locale;
      this.country_code.iso3166_1 = this.countryy.iso3166_1;
      this.caseLocation = {
        latitude: null,
        longitude: null,
      };
      //this.memberLocation.emit(this.country_code);
    }

    this.assistancecase.member_id = null;
    //this.clearMember.emit(true);
    //this.assistancecase.member = new Member(); asignar memeber



    this.setIsMemberDisabled();
    if (country_id) {

      const filter = { 'status': 1, 'country_id': country_id };
      this.api.assistances.get().filter(filter).promise()
        .then(products => this.products = products.data);
    } else {
      this.products = [];
      this.assistanceplans = [];
    }

  }
  setIsMemberDisabled() {
    if (this.assistancecase.country_id != null) {
      this.isMemberDisabled = false;
    } else {
      this.isMemberDisabled = true;
    }
  }

  searchMemberSales(event) {
    if (this.country_id != null) {
      if (this.assistancecase.country_id == null) {
        this.onSelectCountry(this.country_id);
      }

      if (this.searching) {
        return;
      }

      if (this.typeSearch == this.TYPE_SEARCH.BY_CONECTION) {
        //this.selectGestionByConnection();
      } else if (this.typeSearch == this.TYPE_SEARCH.MANUAL_CASE) {

        //this.selectGestionManual();
      } else if (this.typeSearch == 9) {
        this.loaderService.display(true);
        this.searching = true;
        this.api.members.getSales({ 'country': this.country_id, 'sale_status': this.search_sale_status, 'name_or_mobile': this.member_name }).page(this.page).per_page(20).promise()
          .then(
            (data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            }
          )
          .catch(
            (err) => {
              this.loaderService.display(false);
              this.searching = false;
            }
          )
        this.resultDialog = true;
      } else if (this.typeSearch == 10) {
        this.loaderService.display(true);
        this.searching = true;
        this.api.members.getSalesWithAssistanceCode({ 'country': this.country_id, 'sale_status': this.search_sale_status, 'assistance_code': this.member_name }).page(this.page).per_page(20).promise()
          .then(
            (data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            }
          )
          .catch(
            (err) => {
              this.loaderService.display(false);
              this.searching = false;
            }
          )
        this.resultDialog = true;
      } else if (this.typeSearch == 11) {
        this.loaderService.display(true);
        this.searching = true;
        this.api.members.getSalesWithNationalID({ 'country': this.country_id, 'sale_status': this.search_sale_status, 'name_or_mobile': this.member_name }).page(this.page).per_page(20).promise()
          .then(
            (data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            }
          )
          .catch(
            (err) => {
              this.loaderService.display(false);
              this.searching = false;
            }
          )
        this.resultDialog = true;
      } else if (this.typeSearch == 12) {
        this.loaderService.display(true);
        this.searching = true;
        this.api.members.getSalesWithPhone({ 'country': this.country_id, 'sale_status': this.search_sale_status, 'name_or_mobile': this.member_name }).page(this.page).per_page(20).promise()
          .then(
            (data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            }
          )
          .catch(
            (err) => {
              this.loaderService.display(false);
              this.searching = false;
            }
          )
        this.resultDialog = true;
      } else if (this.typeSearch == 99) {
        this.loaderService.display(true);
        this.api.members.getSalesWithCarPlate({ 'country': this.country_id, 'sale_status': this.search_sale_status, 'car_plate': this.member_name }).page(this.page).per_page(20).promise()
          .then(
            (data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            }
          )
          .catch(
            (err) => {
              this.loaderService.display(false);
              this.searching = false;
            }
          )
        this.resultDialog = true;
      } else if (this.typeSearch == 50) {
        this.loaderService.display(true);
        this.api.members.getSalesWithCarEngineNumber({ 'country': this.country_id, 'sale_status': this.search_sale_status, 'engine_number': this.member_name }).page(this.page).per_page(20).promise()
          .then(
            (data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            }
          )
          .catch(
            (err) => {
              this.loaderService.display(false);
              this.searching = false;
            }
          )
        this.resultDialog = true;
      } else if (this.typeSearch == 55) {
        this.loaderService.display(true);
        this.api.members.getSalesWithCarSerialNumber({ 'country': this.country_id, 'sale_status': this.search_sale_status, 'serial_number': this.member_name }).page(this.page).per_page(20).promise()
          .then(
            (data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            }
          )
          .catch(
            (err) => {
              this.loaderService.display(false);
              this.searching = false;
            }
          )
        this.resultDialog = true;
      }
      else if (this.typeSearch == this.TYPE_SEARCH.EMAIL) {
        this.loaderService.display(true);
        this.searching = true;
        this.api.members.getSalesWithEmail({ 'country': this.country_id, 'sale_status': this.search_sale_status, 'email': this.member_name }).page(this.page).per_page(20).promise()
          .then(
            (data) => {
              this.assistancesales = data[0];
              this.totalCount = data[1];
              this.loaderService.display(false);
              this.searching = false;
            }
          )
          .catch(
            (err) => {
              this.loaderService.display(false);
              this.searching = false;
            }
          )
        this.resultDialog = true;
      }



      else if (this.typeSearch == this.TYPE_SEARCH.TAX_NUMBER) {
        this.loaderService.display(true);
        this.searching = true;
        this.api.members
          .getSalesWithTaxNumber({
            country: this.country_id,
            sale_status: this.search_sale_status,
            tax_number: this.member_name,
          })
          .page(this.page)
          .per_page(20)
          .promise()
          .then((data) => {
            this.assistancesales = data[0];
            this.totalCount = data[1];
            this.loaderService.display(false);
            this.searching = false;
          })
          .catch((err) => {
            this.loaderService.display(false);
            this.searching = false;
          });
        this.resultDialog = true;
      }


    } else {
      this.showCountryError = true;
      this.sales = null;
    }

  }

  onClickInfo(index) {
    this.indexselectsale = index;
    //this.op.show(event);
  }
  changeTypeSearch(value) {

    //---todos los bloques de if estaban comentados entonces no hacia nada al entrar a cada if por eso se comento todo
    // if (value == 1) {
    //   //this.changeMessageNavBar.emit(
    //   //  'Create Assistance Case by Coverage Letter'
    //  // );
    // }
    //  else if (value == 8) {
    //   //this.changeMessageNavBar.emit('Create Assistance Case by Conection');
    // } else {
    //   //this.changeMessageNavBar.emit('Create Assistance Case');
    // }
  }

  ASSISTANCE_SALE_STATUSES_TEXT: any = {
    1: 'Active',
    2: 'Delayed',
    3: 'Canceled',
    4: 'Retencion',
    5: 'Modificación',
    6: 'Envio de Kit'
  };

  getStatusText(status: any) {
    if (status in this.ASSISTANCE_SALE_STATUSES_TEXT) {
      return this.ASSISTANCE_SALE_STATUSES_TEXT[status];
    }

    return '';
  }

  editCase(member_id, assistance_id, assistance_plan_id, assistance_sale_id, member_name) {








    const filter = {
      case_id: this.case_id,
      member_id: member_id,
      assistance_id: assistance_id,
      assistance_plan_id: assistance_plan_id,
      assistance_sale_id: assistance_sale_id,
      member_name: member_name


    };
    this.api.assistancecases
      .EditManualCase()
      .filter(filter)
      .promise()
      .then((assistanceCase) => {
        Object.assign(this.assistancecase, assistanceCase);
        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Caso de Asistencia Actualizado',
        });


      })
      .catch((e) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error Actualizando Caso de Asistencia',
        });
      });

    this.hideeditmanual()


  }

  findByConnectionTicket() {
    let ticket = this.assistancetickets.find(ticket => ticket.ticket_type == 12)
    return ticket && true
  }


  setFlagsByTicket() {
    this.assistancetickets.forEach(ticket => {
      if (ticket.ticket_type == 2 && ticket?.provider) {
        this.existProvider = true;
        if (ticket.provider?.network_type == 3) this.dentalLetter = true;
      }
      else if (ticket.ticket_type == 3 && this.assistancecase?.assistance_sale?.category == 'BUCA INSURANCE') { this.blockSteps = true; }
      else if (ticket.ticket_type == 4) { this.codes = true; }
    });
  }

  buca_message(message) {
    this.messageService.add({
      severity: message['status_buca'],
      life: 5000,
      summary: message['summary'],
      detail: message['message']
    });
  }

  showAttachments() {
    this.showUploadFileDialog = true;
    this.getProductAttachments(this.assistancecase.assistance_id, this.assistancecase.assistance_plan_id)
  }

  downloadAttachment(attachment) {
    this.setAttachmentCondicionado.emit(attachment);
    this.showPreviewDialogConditionFile = true;
  }

  closePreviewAttachmentCondicionado() {
    this.showPreviewDialogConditionFile = false;
  }

  getProductAttachments(assitanceId, plassistance_plan_idanId) {
    this.api.conditionalAttachments
      .get(assitanceId, plassistance_plan_idanId)
      .promise()
      .then((response) => {
        this.loaderService.display(false);

        this.caseAttachmentsCondicionado = response.data;
        this.totalCountCaseAttachmentsCondicionado = response.count;
      })
      .catch((e) => {
        this.loaderService.display(false);
      });
  }

  async isAssistanceCaseApp() {
    const dbRefAssistanceCases = ref(this.db, 'asistance_cases');
    const childAssistanceCases = child(dbRefAssistanceCases, this.case_id.toString());
    onValue(childAssistanceCases, (snap) => {
      let data = snap.val();
      this.isCaseApp = data ? true : false;
    });
  }

  openLinkAssistanceCaseApp() {
    this.dialog.open(ClientAssistanceCaseInfoComponent, {
      width: '600px',
      height: '100vh',
      position: { right: '0' },
      panelClass: 'slide-in-dialog',
      data: {
        case_id: this.case_id,
        openInApolo: true
      }
    });

  }



  openSelectSendSurvey() {

    //return
    this.customer_phone = this.assistancecase?.phone;
    this.id_survey = this.assistancecase["survey_id"];
    this.currentProcessId = this.assistancecase?.id;
    this.customer_email = this.assistancecase?.email;
    this.country_id_survey = this.assistancecase?.country.id;
    this.customer_name = this.assistancecase?.member?.name;
    this.open = true;


  }


  showViewFiles() {
    this.getCaseAttachments();
    this.showFilesView = true;
    this.showAudiosDialog = false;
    this.showProgramedService = false;
    this.showExceptionDialog = false;
    this.showBillFormDialog = false;
    this.showBillFormDialogTemp = false;
    this.showDialogGeneral = false;
  }

  getCaseAttachments() {

    this.LoaderService.display(true);

    this.api.caseAttachmentsCases
      .get(this.assistancecase.id)
      .promise()
      .then((response) => {
        this.LoaderService.display(false);
        this.caseAttachments = response.data;
        this.totalCountCaseAttachments = response.count;
      })
      .catch((e) => {
        this.LoaderService.display(false);

        this.translate
          .get('There was an error getting the files')
          .subscribe((msg: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: msg,
            });
          });
      });

  }

  onSaveImport(event) {

    this.filesToImport = event;

    const importFileErrorStatus = this.filesToImport
      .map((attachment) => attachment.status)
      .filter((status) => status === ATTACHMENT_STATUS.INACTIVE);

    if (importFileErrorStatus && importFileErrorStatus.length > 0) {
      this.translate
        .get('Files cannot be imported')
        .subscribe((res: string) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${res}`,
          });
        });

      this.filesToImport = []
      return;
    }

    const payLoad = {
      importFileControl: this.filesToImport,
      caseId: this.assistancecase.id,
    };

    this.filesToImport = [];

    this.LoaderService.display(true);

    this.api.caseAttachmentsCases
      .post(payLoad)
      .promise()
      .then((response) => {
        this.LoaderService.display(false);
        this.caseAttachments = response.data;
        this.totalCountCaseAttachments = response.count;
      })
      .catch((e) => {
        this.LoaderService.display(false);
      });

  }

  downloadAttachmentCases(attachment) {
    this.setAttachment.emit(attachment);
    this.showPreviewDialog = true;
  }

  async getAnswers(assistance_case_id) {
    this.api.assistanceSaleAnswers
      .get(assistance_case_id)
      .promise()
      .then((response) => {
        this.LoaderService.display(false);
        this.answers = response;
        this.answers_text = this.answers
          .map(item => `${item.question_text}: ${item.answer_text}`)
          .join(' ');
      })
      .catch((e) => {
        this.loaderService.display(false);
      });
  }






  showViewReimbursementAmount(groups: any) {

    this.groupsReimbursementAmount = groups;

    this.LoaderService.display(true);

    this.api.assistancecases
      .getCaseReimbursementAmounts(this.assistancecase.id)
      .promise()
      .then((response) => {
        if (response['hasReimbursementAmount']) {
          this.hasCaseReimbursementAmount = true;
        }

        this.LoaderService.display(false);
        this.showReimbursementAmount = true;
      })
      .catch((e) => {
        this.LoaderService.display(false);
        this.showReimbursementAmount = false;
        this.translate.get('An error occurred').subscribe((res: string) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: res,
          });
        });
      });
  }







  onSaveCaseReimbursementAmount() {



    let stringAreas = ''
    this.selectedAreasReembolso.forEach((element) => {

      stringAreas += element.name + ','

    })
    stringAreas = stringAreas.substring(0, stringAreas.length - 1)

    let stringReasons = ''
    this.selectedReasonsReembolso.forEach(element => stringReasons += element.name + ',')

    let lastTicket: AssistanceTicket;
    lastTicket = _.cloneDeep(this.groupsReimbursementAmount[0]);

    // Set ticket type to comment 9
    lastTicket.ticket_type = 9;
    lastTicket.comment = null;

    if (this.assistancecase.reimbursement_amount) {
      let otherCosts = '';
      if (this.assistancecase.reimbursement_waiting_hours) otherCosts += `Costo por horas extra: ${this.assistancecase.reimbursement_waiting_hours} `
      if (this.assistancecase.reimbursement_maneuers) otherCosts += `; Maniobras: ${this.assistancecase.reimbursement_maneuers} `
      if (this.assistancecase.reimbursement_pension) otherCosts += `; Pensión: ${this.assistancecase.reimbursement_pension} `

      lastTicket.comment = `Se registro monto del reembolso con fecha ${moment(this.assistancecase.reimbursement_date).format("DD/MM/YYYY")}, por la cantidad de ${this.assistancecase.country.currency_symbol}${this.assistancecase.reimbursement_amount}, ${otherCosts} ${this.reimburseAmountComment} `;
    }

    lastTicket.case_id = Number(this.case_id);
    lastTicket.user_id = Number(this.user_id);
    lastTicket.datetime = null;

    let payload = {
      case_id: this.assistancecase.id,
      reimbursement_date: moment(this.assistancecase.reimbursement_date).format("YYYY-MM-DD"),
      reimbursement_amount: this.assistancecase.reimbursement_amount,
      reimbursement_waiting_hours: this.assistancecase.reimbursement_waiting_hours,
      reimbursement_maneuers: this.assistancecase.reimbursement_maneuers,
      reimbursement_pension: this.assistancecase.reimbursement_pension,
      ticket_comment: lastTicket,
      reimbursement_area: stringAreas,
      reimbursement_types: stringReasons,
      reimbursement_request_date: moment(this.assistancecase.reimbursement_request_date).format("YYYY-MM-DD"),
      reimbursement_supervisor_id: this.assistancecase.reimbursement_supervisor_id,
      reimburseAmountComment: this.reimburseAmountComment
    };

    this.LoaderService.display(true);

    this.api.caseReimbursementAmounts
      .post(payload)
      .promise()
      .then((tickets) => {
        this.LoaderService.display(false);
        this.showReimbursementAmount = false;
        this.translate.get('Saved Reimbursement Amount').subscribe((res: string) => {
          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: res,
          });
        });

        const orderticket = tickets.reverse();
        this.assistancetickets = orderticket.concat(this.assistancetickets);
        this.totalCount = this.totalCount + orderticket.length;
        //this.autoStepshow(orderticket[0], false);
        this.autocloseCase(orderticket[0]);
      })
      .catch((e) => {
        this.LoaderService.display(false);
        this.showReimbursementAmount = false;
        this.translate
          .get('An error occurred while trying to save Reimbursement Amount')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: res,
            });
          });
      });

  }


  loadSupervisors() {
    this.api.assistancetickets.getExceptionSupervisor().promise()
      .then(supervisors => {
        this.supervisors_reimbursements = supervisors;
        this.LoaderService.display(false)
      });
  }
  viewCallDialog() {

    if (this.assistancecase.latitude == null || this.assistancecase.latitude == 0 || this.assistancecase.longitude == null || this.assistancecase.longitude == 0) {
      this.showRequestLocation = true;
    } else {
      Swal.fire({
        title: "El cliente ya ha enviado su ubicación",
        text: "¿Deseas solicitar nuevamente la ubicación?",
        icon: 'warning',
        allowOutsideClick: true,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        confirmButtonColor: "#015999",
        width: '800px',
        customClass: {
          popup: 'my-swal'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.showRequestLocation = true;
        }
      });

    }

  }


  //---para enviar link de localización al cliente
  requestLocation(shippingMethod: number) {

    //---sino tiene una location key quiere decir que no se ha generado un link de ubicacion
    //-- asi que envio una url de ubicacion del cliente 
    //this.assistancecase.location_key=null;
    // if(this.assistancecase.location_key=="" || this.assistancecase.location_key==null){
    // this.location_key=this.generateRandomString(10)
    //---en el backend valido si ya existe un location key
    this.api.assistanceCasesById
      .getLocationKeyUnique(this.assistancecase.id)
      .promise()
      .then((response) => {
        //---genero un uuid nuevo
        this.location_key_update = response.uuid
        this.assistancecase.location_key_update = this.location_key_update;
        //---aqui tendria que ir a actualizar el  this.assistancecase.location_key en la base de datos

        this.api.assistanceCasesById
          .updateLocationKey(this.case_id, this.location_key_update)
          .promise()
          .then((c) => {
            //console.log("actualice el location key")
            this.assistancecase.location_key_update = this.location_key_update;
            this.sendRequestLocation(shippingMethod)

          }).catch(error => {
            // console.log("No se pudo actualizar el location key")
          })

      }).catch(error => {
        // console.log("No se pudo actualizar el location key")
      })



    // }else {
    //   this.sendRequestLocation(shippingMethod)
    // }

  }

  sendRequestLocation(shippingMethod) {
    const requiresDestination =
      this.service?.required_address_destination === 1 ? 1 : 0;

    if (
      this.assistancecase.email &&
      shippingMethod == this.selectLocationComponent.SHIPPING_METHOD.EMAIL
    ) {
      this.selectLocationComponent.sendMessage(
        this.selectLocationComponent.SHIPPING_METHOD.EMAIL,
        this.location_key,
        null,
        requiresDestination,
      );
    } else {
      this.selectLocationComponent.sendMessage(
        shippingMethod,
        this.location_key,
        null,
        requiresDestination,
      );
    }
  }


  onSelectLocation(location) {
    // console.log("ESTOY RECIBIENDO LA UBICACION DESDE EL LINK Y LOS DATOS SON ",location)
    // if(location["location_key"]){

    //   //----VALIDAR ESTO, ESTO ES EN CASO SE ENVIEN VARIOS LINKS AL CLIENTE Y SE QUIERE QUE FUNCIONE CUALQUIERA, SINO SOLO FUNCIONARIA EL ULTIMO ENVIADO
    //   if(location["location_key"]!="" && location["location_key"]!=this.location_key){
    //     this.location_key=location["location_key"] //la location_key que venga en el link es la que voy a enviar
    //   }

    // }
    //this.loaderLocation = false;
    this.editLocation.latitude = location.latitude;
    this.editLocation.longitude = location.longitude;
    //--mando a actualizar la posicion del cliente en el mapa
    this.updateMarkerPosition(this.editLocation.latitude, this.editLocation.longitude)
    //---vuelvo a pintar el mapa
    this.fitMap();



    const coordinates = {
      latitude: location.latitude,
      longitude: location.longitude,
    };



    //---cuando reciba tengo que actualizar el case location tambien

    this.setCoordinates(location.latitude, location.longitude)


    this.api.assistancecases
      .get_geolocation_by_coordinates(coordinates)
      .post()
      .promise()
      .then((resp) => {
        setTimeout(() => {
          if (resp.result) {
            this.google_address_origen = resp.complete_address;
            this.assistancecase.area = this.assistancecase.area
              ? this.assistancecase.area
              : resp.mayoralty;
            this.assistancecase.suburb = this.assistancecase.suburb
              ? this.assistancecase.suburb
              : resp.neighborhood;
            this.assistancecase.street = this.assistancecase.street
              ? this.assistancecase.street
              : resp.street_number;
            this.assistancecase.postal_code = resp.postal_code
              ? resp.postal_code
              : '00000';
            this.assistancecase.reference = this.assistancecase.reference
              ? this.assistancecase.reference
              : resp.reference;

            // if (
            //   this.caseForm &&
            //   this.caseForm.form &&
            //   this.caseForm.form.controls
            // ) {
            //   this.caseForm.form.controls.area?.patchValue(
            //     this.assistancecase.area
            //   );
            //   this.caseForm.form.controls.suburb.patchValue(
            //     this.assistancecase.suburb
            //   );
            //   this.caseForm.form.controls.street.patchValue(
            //     this.assistancecase.street
            //   );
            //   this.caseForm.form.controls.postal_code.patchValue(
            //     this.assistancecase.postal_code
            //   );
            //   this.caseForm.form.controls.reference.patchValue(
            //     this.assistancecase.reference
            //   );
            // }
          }
        }, 1);
      })
      .catch((e) => {
        this.createCurrentAddress();
      });
  }

  updateMarkerPosition(newLat: number, newLng: number) {
    const marker = this.mapOverlays.find(m => m.getTitle() === 'Ubicacion Cliente');

    if (marker) {
      //alert("Ubicación del cliente recibida")
      Swal.fire({
        title: "Ubicación del cliente recibida",
        icon: 'success',
        allowOutsideClick: true,
        showConfirmButton: true,
        width: '800px',
        confirmButtonColor: "#015999",
        customClass: {
          popup: 'my-swal'
        },
      });

      marker.setPosition(new google.maps.LatLng(newLat, newLng));
      this.assistancecase.latitude = newLat;
      this.assistancecase.longitude = newLng;
      //console.log('Marcador actualizado:', newLat, newLng);
      // console.log("el marcador es ",marker)
    } else {
      //---sino existe tengo que crear el marcador
      // console.log('Marcador no encontrado, lo voy a crear');
      //alert("Ubicación del cliente recibida")
      Swal.fire({
        title: "Ubicación del cliente recibida",
        icon: 'success',
        allowOutsideClick: true,
        showConfirmButton: true,
        width: '800px',
        confirmButtonColor: "#015999",
        customClass: {
          popup: 'my-swal'
        },
      });
      this.assistancecase.latitude = newLat;
      this.assistancecase.longitude = newLng;
      this.mapOverlays.push(
        new google.maps.Marker({
          position: {
            lat: this.assistancecase.latitude,
            lng: this.assistancecase.longitude,
          },
          title: 'Ubicacion Cliente',
          icon: 'https://storage.googleapis.com/apolo11-prod.appspot.com/assets/images/others/location_provider22.png',
        })
      );

    }
  }


  createCurrentAddress() {
    if (!this.assistancecase.address) {
      this.assistancecase.address = `${this.assistancecase.area || ''} ${this.assistancecase.postal_code || ''
        } ${this.assistancecase.street || ''} ${this.assistancecase.zone || ''} ${this.assistancecase.suburb || ''
        }`;
    } else if (this.google_address_origen != '') {
      this.assistancecase.address =
        this.assistancecase.address + ` (${this.google_address_origen})`;
      // this.caseForm.form.controls.assistancecase_address.patchValue(
      //   this.assistancecase.address
      // );
    }
  }


  generateRandomString(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }



  onRadioPhoneChange(value) {
    if (value == 1) {
      this.checkedPhone = true;
      this.checkedPhone2 = false;
      this.selectedPhone = 1;

    } else {
      this.checkedPhone = false;
      this.checkedPhone2 = true;
      this.selectedPhone = 2;

    }
  }



  getTipologies() {
    this.api.typologies
      .get()
      .params({ catalog: 'member_classification' })
      .promise()
      .then((response) => {
        this.client_classification = response.data[0]?.typologies || [];
      })
      .catch((e) => {
        this.translate
          .get('Error fetching typologies')
          .subscribe((res: string) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `${res}: ${e.error}`,
            });
          });
      });
  }

  getUrlImageMemberClassification(member_classification: number) {
    let url = '';
    this.client_classification.forEach((element) => {
      if (parseInt(element.value_) === member_classification) {
        url = element.description;
      }
    });
    return url;
  }

  getLetter() {
    this.api.assistancesales.getLetter(this.case_id).promise()
      .then((images) => {
        this.images = images[0];
      })
      .catch((e) => { });
  }

  setCoordinates(latitude, longitud) {

    if (latitude != null && latitude != 0 && longitud != null && longitud != 0) {
      this.have_coordinates = true;
      this.msgs = [
        { severity: 'success', summary: '', detail: 'Geolocalización recibida' }
      ];



    } else {
      this.have_coordinates = false;

      this.msgs = [
        { severity: 'error', summary: '', detail: 'El caso no tiene ubicación' }
      ];
    }


    if (this.have_coordinates) {
      this.caseLocation = {
        latitude: latitude,
        longitude: longitud,
      };
    }

  }

  openInlineChat(ticket: any) {
    this.selectedTicket = ticket;
    this.showChatModal = true;
  }
  validateCaseLinkService(caseId): any {
    let payload = {
      case_id: caseId
    }

    this.api.assistancecases
      .validateLinkService(payload)
      .promise()
      .then((response) => {
        this.LoaderService.display(false);
        this.applyLinkService = response['link_service_active']
      })
      .catch((e) => {
        this.LoaderService.display(false);
        this.applyLinkService = false;
      })
  }
  openChat() {
    if (!this.isRoadmapContactChannel()) {
      return;
    }
    const caseId = this.route.snapshot.params['id'];
    this.api.assistanceCaseLink.activateChat({
      case_id: caseId,
      member_id: this.assistancecase.member.id,
      member_name: this.assistancecase.member.name,
      source: 'assistance_tickets',
    }).subscribe({
      next: (chatMeta: any) => {
        if (chatMeta?.created === false) {
          return;
        }
        this.canReply = true;
        this.chatMessages = [];
        this.loadChatMessages(caseId);
        this.showChatDialog = true;
      },
      error: () => {
        const db = getDatabase();
        const refActive = ref(db, `assistance_chat_active/${caseId}`);
        get(refActive).then(snapshot => {
          this.canReply = snapshot.exists();
          if (snapshot.exists()) {
            this.chatMessages = [];
            this.loadChatMessages(caseId);
          }
          this.showChatDialog = true;
        });
      },
    });
  }

  isRoadmapContactChannel(): boolean {
    return Number(this.assistancecase?.contact_channel) === 3;
  }


  markMessagesAsSeen(caseId, chat) {

    const db = getDatabase();
    const updates = {};

    chat.forEach(msg => {
      // Solo actualizamos si no ha sido visto y viene de otro (no del user)
      if (msg.from !== 'cabin' && msg.seen !== true && msg.key) {
        updates[`assistance_chat/${caseId}/${msg.key}/seen`] = true;
      }
    });

    if (Object.keys(updates).length > 0) {
      update(ref(db), updates)
        .then(() => { })
        .catch(err => { });
    }
  }
  private messagesRef: any = null;
  private messageListener: any = null;
  loadChatMessages(caseId: string) {
    const db = getDatabase();
    this.messagesRef = ref(db, `assistance_chat/${caseId}`);
    const chats = []


    // 💡 Definir el listener como función separada
    this.messageListener = (snapshot: any) => {
      const msg = snapshot.val();
      msg.key = snapshot.key;
      this.chatMessages.push(msg);
      chats.push(msg);
      this.markMessagesAsSeen(caseId, chats);
      this.scrollToBottom();
    };

    onChildAdded(this.messagesRef, this.messageListener);
  }


  sendMessage(
    content: string = '',
    type: 'text' | 'image' | 'audio' | 'file' | 'location' = 'text',
    url: string = '',
    fileName: string = ''
  ) {
    const caseId = this.route.snapshot.params['id'];;
    if (!this.canReply || !caseId) return;

    if (type === 'text') {
      content = this.chatInput.trim();
      if (!content) return;
    }

    const message = {
      from: 'cabin',
      type,
      text: type === 'text' ? content : '',
      url: url || '',
      file_name: fileName || '',
      url_google: '',
      url_waze: '',
      author: this.iAm(['operator']) ? this.assistancecase.created_by_user.name : this.assistancecase.created_by.name,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      seen: false
    };
    this.sendMessageToFirebase(message);
    if (type === 'text') this.chatInput = '';
    setTimeout(() => this.scrollToBottom(), 300);
  }


  sendMessageToFirebase(message: any) {
    const caseId = this.route.snapshot.params['id'];;
    if (!caseId) return

    const db = getDatabase();
    const messagesRef = ref(db, `assistance_chat/${caseId}`);
    const newRef = push(messagesRef);

    set(newRef, message)
      .then(() => {
        this.sendPushNotification('text', message.text, message.from, null)
      })
      .catch(err => { });
  }


  scrollToBottom() {
    setTimeout(() => {
      if (this.scrollContainer) {
        this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
      }
    }, 200);
  }



  sendLocation() {
    const caseId = this.route.snapshot.params['id'];

    navigator.geolocation.getCurrentPosition(position => {
      const lat = position.coords.latitude;
      const lon = position.coords.longitude;
      const locationMsg = {
        from: 'cabin',
        type: 'location',
        url_google: `https://www.google.com/maps?q=${lat},${lon}`,
        url_waze: `https://waze.com/ul?q=${lat},${lon}`,
        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        seen: false
      };
      const db = getDatabase();
      const refDb = ref(db, `assistance_chat/${caseId}`);
      const newRef = push(refDb);
      set(newRef, locationMsg).then(() => {
        this.sendPushNotification('location', null, locationMsg.from, null)
      })
        .catch(err => { });;
    });
  }

  openFilePicker() {
    setTimeout(() => {
      if (this.fileInput) {
        this.fileInput.nativeElement.click();
      } else {
      }
    }, 0);
  }
  selectedFiles: File[] = [];

  handleFileInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (!files) return;

    Array.from(files).forEach(async file => {
      this.selectedFiles.push(file);

      const type = file.type.startsWith('image') ? 'image' :
        file.type.startsWith('audio') ? 'audio' : null;

      if (type) {
        const reader = new FileReader();
        reader.onload = async (e: any) => {

          await this.uploadFileToBackend(file, file.name, type);

        };
        reader.readAsDataURL(file);
      } else {

        await this.uploadFileToBackend(file, file.name, 'file');

      }

    });
  }

  async uploadFile(file: File) {
    try {
      const path = await this.storageService.uploadFile(file);
      const typeValue = this.determineFileType(file);
      this.sendMessage('', typeValue, path, file.name);
    } catch (error) {
    }
  }

  determineFileType(file: File): 'image' | 'audio' | 'file' {
    const extension = file.name.split('.').pop()?.toLowerCase();
    if (!extension) return 'file';
    if (['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(extension)) return 'image';
    if (['mp3', 'wav', 'aac', 'webm'].includes(extension)) return 'audio';
    return 'file';
  }

  viewFile(message: any) {
    if (message.type === 'image') {
      Swal.fire({
        imageUrl: message.url,
        imageWidth: '90%',
        confirmButtonText: 'Cerrar',
        customClass: {
          popup: 'custom-swal-zindex'
        },
        target: 'body'

      });
    } else if (message.type === 'pdf' || message.type === 'document') {
      window.open(message.url, '_blank');
    } else if (message.type === 'audio') {
      const audio = new Audio(message.url);
      audio.play();
    }
  }

  closeChatPanel() {
    this.showChatDialog = false;
    if (this.messagesRef && this.messageListener) {
      off(this.messagesRef, 'child_added', this.messageListener);
      this.messageListener = null;
      this.messagesRef = null;
      this.chatMessages = [];
    }
  }

  showAttachOptions = false;

  toggleAttachOptions() {
    this.showAttachOptions = !this.showAttachOptions;
  }

  closeAttachOptions() {
    this.showAttachOptions = false;
  }

  takePhoto() {
    this.cameraInput.nativeElement.click();
  }

  async openGallery() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.multiple = false;
    input.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = async (e: any) => {

          await this.uploadFileToBackend(file, file.name, 'image');

        };
        reader.readAsDataURL(file);
      }
    };
    input.click();
  }

  private async uploadFileToBackend(file: File, fileName: string, type: string) {
    try {
      const path = await this.createFile(file); // 🔥 Este debe devolver el downloadURL

      const newMessage = {
        from: 'cabin',
        type: type,
        text: '',
        url: path,
        file_name: fileName,
        url_google: null,
        url_waze: null,
        author: 'Cabin',
        time: this.getCurrentTime(),
        seen: false
      };

      const db = getDatabase();
      const messagesRef = ref(db, `assistance_chat/${this.case_id}`);
      const newMessageRef = push(messagesRef);

      await set(newMessageRef, newMessage);
      this.sendPushNotification(type, null, newMessage.from, path)
    } catch (err) {
    }
  }

  getCurrentTime(): string {
    const now = new Date();
    return now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }


  async createFile(file: File): Promise<string> {
    try {
      const downloadURL: string = await this.storageService.uploadAssistanceLinkFile(file) as string;
      return downloadURL;
    } catch (error) {
      return '';
    }
  }
  sendPushNotification(type, message, role, url) {
    // "type": audio|text|file|location|photo,
    let payload = {
      case_id: this.case_id,
      type: null,
      message: null,
      role: null,
      url: null

    }
    if (type) payload['type'] = type;
    if (message) payload['message'] = message;
    if (role) payload['role'] = role;
    if (url && type === 'image') payload['url'] = url;


    this.api.assistanceCaseLink.postPushNotificationPrivate(payload).promise().then((res) => {
      console.log('Push notification sent successfully', res);
      console.log('Payload:', payload);
    })
      .catch((err) => {
        console.error('Error sending push notification', err);
      })
  }


  iconActions: IconAction[] = [
    {
      icon: 'company/assets/images/assistancecase/iconsv2/programar2.svg',
      title: 'Program',
      click: (sg) => this.setProgramedTicket(this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.iAm(['assistance_admin', 'supervisor']) && this.ticketbtnshow[sg.service_id] === false
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/programar2.svg',
      title: 'Program',
      click: (sg) => this.setProgramedTicket(this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.iAm(['assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical']) && this.ticketbtnshow[sg.service_id] === true
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/costo_total.svg',
      title: 'By Connection',
      click: (sg) => this.setByConectionTicket(this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.iAm(['assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical']) && this.ticketbtnshow[sg.service_id] === true
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/recordination.svg',
      title: 'Recordination',
      click: (sg) => this.setByRecordinationTicket(this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.iAm(['assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical']) && this.ticketbtnshow[sg.service_id] === true
    },
    // {
    //   icon: 'company/assets/images/assistancecase/iconsv2/excepción2.svg',
    //   title: 'Exception',
    //   click: (sg) => this.setException(this.servicegrouptickets[sg.service_id]),
    //   condition: (sg) => this.iAm(['assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical'])
    // },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/asistencia%3Fcortesia.svg',
      title: 'Courtesy',
      click: (sg) => this.setCourtesy(this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.iAm(['assistance_admin', 'supervisor']) && this.ticketbtnshow[sg.service_id] === true
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/facturar.svg.svg',
      title: 'Bill',
      click: (sg) => this.startCreategroupTicket(this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.iAm(['assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical']) && this.ticketbtnshow[sg.service_id] === true && this.gettickettypefromGroup(this.servicegrouptickets[this.servicegroups[0].service_id], 4)
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/encuesta.svg',
      title: 'Survey',
      click: () => this.openSelectSendSurvey(),
      condition: () => this.assistancecase?.survey_id && this.gettickettypefromGroup(this.servicegrouptickets[this.servicegroups[0].service_id], 4) && this.iAm(['assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'quality', 'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical'])
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/escuchar_audios2.svg',
      title: 'Listen to audio',
      click: () => this.viewaudios(),
      condition: () => this.iAm(['admin', 'assistance_admin', 'supervisor', 'quality', 'networkleader'])
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/evento_riesgoso.svg',
      title: 'Risk event',
      click: (sg) => this.viewRisks(this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.iAm(['admin', 'assistance_admin', 'supervisor', 'quality', 'operator', 'assistance_dispatcher', 'assistance_dispatcher_medical', 'assistance_dispatcher_vial'])
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/posible_queja.svg',
      title: 'Possible complaint',
      click: (sg) => this.viewComplaints(this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.iAm(['admin', 'assistance_admin', 'supervisor', 'quality', 'operator', 'assistance_dispatcher', 'assistance_dispatcher_medical', 'assistance_dispatcher_vial'])
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/dollar-circle.svg',
      title: 'Service by reimbursement',
      click: (sg) => this.setReimburse(this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.iAm(['admin', 'assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical', 'operator_reimbursement']) && !this.hasTicketReimburse && this.ticketbtnshow[sg.service_id] === true
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/coins-circle.svg',
      title: 'Reimbursement Amount',
      click: (sg) => this.showViewReimbursementAmount(this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.iAm(['admin', 'assistance_admin', 'supervisor']) && this.hasTicketReimburse && this.ticketbtnshow[sg.service_id] === true
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/doc-circle.svg',
      title: 'Files',
      click: () => this.showViewFiles(),
      condition: () => this.iAm(['admin', 'assistance_admin', 'supervisor', 'assistance_dispatcher_medical'])
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/reasignar_triangemod.svg',
      title: 'Reassign Triage',
      click: (sg) => this.ReassignTriage(sg.service_id),
      condition: (sg) => this.iAm(['assistance_admin', 'supervisor']) && this.ambulance_id.indexOf(sg.service_id) >= 0
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/carta.svg',
      title: 'Letter of Participation',
      click: (sg) => this.formcartaau(3, this.servicegrouptickets[sg.service_id]),
      condition: () => this.existProvider && this.copago
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/programar2.svg',
      title: 'Schedule Appointment',
      click: () => this.showScheduleApooinment(),
      condition: () => this.provider
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/carta_autorizacion.svg',
      title: 'Letter of Authorization',
      click: (sg) => this.formcartaau(1, this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.existProvider && !this.copago && sg.service.category.id != 18 && !this.dentalLetter
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/carta_autorizacion_vet.svg',
      title: 'Letter of Authorization Vet',
      click: (sg) => this.formcartaau(4, this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.existProvider && sg.service.category.id == 18
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/carta_descuento.svg',
      title: 'Letter of Discount',
      click: (sg) => this.formcartaau(2, this.servicegrouptickets[sg.service_id]),
      condition: () => this.existProvider
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/ver_carta.svg',
      title: 'Show letter',
      click: () => this.showPreviewAttachment(this.images[0]),
      condition: () => this.existProvider
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/edit.svg',
      title: 'Edit Manual Case',
      click: () => this.editmanualcase(),
      condition: () => true
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/condicionados.svg',
      title: 'Open Conditional Files',
      click: () => this.showAttachments(),
      condition: () => true
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/historial-casos.svg',
      title: 'Open History Cases',
      click: () => this.showCaseHistory(),
      condition: () => true
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/buca1.svg',
      title: 'Get BUCA Codes',
      click: () => this.getBucaCodes(),
      condition: () => this.additionalplanservice?.buca_apply == 1 && this.codes
    },
    {
      icon: 'company/assets/images/assistancecase/iconsv2/carta-auto-buca.svg',
      title: 'Dental authorization letter',
      click: (sg) => this.formcartaau(5, this.servicegrouptickets[sg.service_id]),
      condition: () => this.existProvider && this.dentalLetter
    },
    {
      icon: 'APOLO/assets/images/assistancecase/iconsv2/auth-exception.svg',
      title: 'Exceptions',
      click: (sg) => this.openExceptionSwal(this.servicegrouptickets[sg.service_id]),
      condition: (sg) => this.iAm(['admin', 'assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical', 'operator_reimbursement', 'cabin_exception_admin']) && this.CabinException == false
    },
    {
      icon: 'APOLO/assets/images/assistancecase/iconsv2/auth-confirm.svg',
      title: 'Authorize exceptions',
      click: (sg) => this.openAuthorization(),
      condition: (sg) => this.iAm(['admin', 'assistance_admin', 'supervisor', 'cabin_exception_admin']) && this.CabinException == true && this.CabinExceptionAuthorized == false
    }
  ]

}




class AssistanceCases {
  status: number;
}
